import React, { useEffect, useRef } from "react";
import PostVideo from "./common/PostVideo";
import axios from "axios";
import ShopCardList from "./shopbuyeformarketplace/ShopCardList";
import Modal from "react-modal"; // Install react-modal for modal functionality
import calendericon from "../assets/images/icons/calendar.svg";
import livesicon from "../assets/images/icons/lives.svg";
import { FaBell, FaCommentAlt, FaHeart, FaShare, FaSearch, FaChevronDown, FaMapMarkerAlt } from "react-icons/fa";
import pipaanlogo from "../assets/pipaanlogo.svg";
import intresticon from "../assets/images/icons/intrest-icon.png";
import groupimg from "../assets/groupimg.png";
import { Search, Save, RefreshCcw } from "lucide-react";
import userimg from "../assets/user.png";
import profileimg from "../assets/profile.png";
import share from "../assets/share.png";
import newsfeed from "../assets/images/icons/newsfeed.png";
import calendar from "../assets/images/icons/calendar.png";
import like from "../assets/images/icons/like.png";
import calender from "../assets/images/icons/calendar-icon.png";
import location from "../assets/images/icons/location.png";
import editcover from "../assets/images/icons/edit-p.svg";
import edit from "../assets/images/icons/edit.png";
import mobile from "../assets/images/icons/mobile.png";
import house from "../assets/images/icons/house.png";
import friendsfollowers from "../assets/images/icons/friendsandfollowers.png";
import groupsandfamily from "../assets/images/icons/groupandfamily.png";
import chats from "../assets/images/icons/chats.png";
import profile from "../assets/images/icons/profile.png";
import camera from "../assets/images/icons/camera.svg";
import locationicon from "../assets/images/icons/location.png";
import mobileicon from "../assets/images/icons/mobile.png";
import Account from "../assets/images/icons/account-setting.png";
import help from "../assets/images/icons/helpandsupport.png";
import logout from "../assets/images/icons/logout.png";
import notification from "../assets/images/icons/notification.png";
import gallery from "../assets/images/icons/gallery.svg";
import video from "../assets/images/icons/video.svg";
import taguser from "../assets/images/icons/tag-user.svg";
import send from "../assets/images/icons/send.svg";
import global from "../assets/images/icons/global.svg";
import greenglobal from "../assets/images/icons/green-global.png";
import hamburger from "../assets/images/icons/hamburger.png";
import hamburgerclose from "../assets/images/icons/hamburgerclose.png";
import closecircle from "../assets/images/icons/close-circle.png";
import FeedPost from "./feedpost/FeedPost";
import profileData from "./feedpost/profiledata";
import { Menu, X, Bell, User, Home } from "lucide-react";
import { useState } from "react";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { FaTimes } from "react-icons/fa";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation, Pagination } from "swiper/modules";
import profilebanner from "../assets/images/Profile-banner.png";
import Leftsidebar from "./sidebar/leftsidebar"
import LeftResponsivesidebar from "./sidebar/left-responsive"
import Rightsidebar from "./sidebar/rightsidebar"
import RightResponsivesidebar from "./sidebar/right-responsive"
import Headmenu from "./sidebar/headmenu"
import Sharepost from "./sharepost"
import postone from "../assets/images/post-1.png";
import posttwo from "../assets/images/post-2.png";
import postthree from "../assets/images/post-3.png";
import { useNavigate } from "react-router-dom"; // ✅ Import useNavigate
import ReactPlayer from "react-player";
import play from "../assets/play.png";
import viewIcon from "../assets/images/icons/viewIcon.png";
import likeIcon from "../assets/images/icons/likeIcon.png";
import shareIcon from "../assets/images/icons/shareIcon.svg";
import commentIcon from "../assets/images/icons/commentIcon.svg";
import smileyIcon from "../assets/images/icons/smileyIcon.png";
import Loacationtick from "../assets/images/icons/location-tick.png";
import { useParams } from "react-router-dom";
import RedlikeIcon from "../assets/images/icons/redlikeIcon.svg";
import Whiteheart from "../assets/images/icons/white-heart.svg";
import { toast } from "react-toastify";
// import { Picker } from 'emoji-mart';
// import 'emoji-mart/css/emoji-mart.css'; // Import the CSS for emoji picker
import galleryicon from "../assets/images/icons/gallery.svg";
import videoicon from "../assets/images/icons/video.svg";
import { Thumbs } from "swiper/modules";
import morecircle from "../assets/images/icons/more-circle.svg";
import goliveprf from "../assets/images/golive-prf.png";
import crtpostimg from "../assets/images/crtpostimg.png";
import messagetext from "../assets/images/icons/message-text.png";
import leftconnect from "../assets/images/icons/leftconnect.png";
import Redheart from "../assets/images/icons/red-heart.svg";
import data from "@emoji-mart/data";
import Picker from '@emoji-mart/react';
import { formatDateTime, formatDateOnly, formatCalendarDateUTC } from "../utils/date";
import verifybadge from "../assets/images/icons/verify-badge.svg";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
function ProgressBar({ current, max, percentage, donatorsCount, daysLeft }) {
  return (
    <div className="max-w-screen-lg w-full mt-2">
      <div className="flex justify-between text-[500] text-[12px] mb-2">
        <p className="text-[#141414] font-[500]">${current}<span className="text-[#666666] font-[500]"> from ${max}</span></p>
      </div>
      <div className="w-auto bg-[#CCCCCC] rounded-full h-2 relative overflow-hidden max-w-[500px]">
        <div
          className="bg-[#077734] h-2 rounded-full flex items-center px-2 text-white text-sm font-semibold"
          style={{ width: `${percentage}%` }}
        >
          {/* ${current}3 */}
        </div>
        {/* <div
                    className="absolute top-1/2 transform -translate-y-1/2 w-4 h-4 bg-green-900 rounded-full"
                    style={{ left: `calc(${percentage}% - 8px)` }}
                /> */}
      </div>
      <div className="flex justify-between text-[500] text-[12px] my-2  max-w-[500px]">
        <p className="text-[#141414] font-[500]">{donatorsCount}<span className="text-[#666666] font-[400]"> Donators</span></p>
        <p className="text-[#141414] font-[500]">{daysLeft}<span className="text-[#666666] font-[400]"> days left</span></p>
      </div>
    </div>
  );
}
export default function ProfileView() {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate(); // ✅ Initialize navigation function
  const [playingIndex, setPlayingIndex] = useState(null);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0); // Track active slide

  const videoUrls = [
    "https://youtube.com/shorts/G5xF0A-HcnQ?feature=shared", "https://youtube.com/shorts/h8wUVsH9ekU?feature=shared", "https://youtube.com/shorts/6AwVtn0Sxl0?feature=shared", "https://youtube.com/shorts/06w3yBAACyM?feature=shared", "https://youtube.com/shorts/yd5l2a2xLVc?feature=shared", "https://youtube.com/shorts/5sFsjYADiKY?feature=shared", "https://youtube.com/shorts/qL2YS-ULKFc?feature=shared"
  ];
  console.log("Video URLs:", videoUrls);

  const [profileImage, setProfileImage] = useState(profileimg);
  const [coverImage, setCoverImage] = useState(profilebanner);
  const [username, setUsername] = useState("User123");
  const [followers, setFollowers] = useState([]);
  // The viewed user's "Who can see the people, Pages and lists you follow?" hides their list from this viewer
  const [followersHidden, setFollowersHidden] = useState(false);
  const [bio, setBio] = useState("This is my bio");
  const [dob, setDob] = useState("2000-01-01");
  const [location, setLocation] = useState("New York, USA");
  const [mobile, setMobile] = useState("+1234567890");
  const [isFollowing, setIsFollowing] = useState(false);
  const [postContent, setPostContent] = useState("");
  const [posts, setPosts] = useState([]);  // ✅ Store fetched posts
  const [likedUsers, setLikedUsers] = useState([]); // State to store users who liked a post
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal state
  const [longPressTimeout, setLongPressTimeout] = useState(null); // Timeout for long press
  const [commentInputs, setCommentInputs] = useState({}); // State to store comment inputs for each post
  const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false); // Modal state for comments
  const [comments, setComments] = useState([]); // State to store comments
  const [selectedPostId, setSelectedPostId] = useState(null); // Track the post ID for the modal

  const [expandedPosts, setExpandedPosts] = useState(Array(profileData.length).fill(false)); // Ensure consistent hook call
  // ✅ Define state properly
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState(""); // ✅ Store post content
  const [mediaUrl, setMediaUrl] = useState(""); // ✅ Store media URL (if any)
  const [loading, setLoading] = useState(false); // ✅ Handle loading state
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [taggedUserIds, setTaggedUserIds] = useState([]);  // Store tagged user IDs
  const [showDropdown, setShowDropdown] = useState(false);  // Toggle user list dropdown
  const [filteredUsers, setFilteredUsers] = useState([]);  // Store filtered users
  const [cursorPosition, setCursorPosition] = useState(0);  // Track cursor for dropdown
  const [currentDateTime, setCurrentDateTime] = useState('');
  const [tags, setTags] = useState([]);
  const [showLocationPage, setShowLocationPage] = useState(false);
  const [locationInput, setLocationInput] = useState(""); // State for location input
  const [locationSuggestions, setLocationSuggestions] = useState([]); // State for location suggestions
  const [loadingLocations, setLoadingLocations] = useState(false); // Loading state for locations
  const [selectedLocation, setSelectedLocation] = useState(""); // State for selected location
  const [uploadedMedia, setUploadedMedia] = useState([]);
  const [showTagInput, setShowTagInput] = useState(false);
  const [hasMore, setHasMore] = useState(true);  // ✅ Flag to track if there are more posts
  const [page, setPage] = useState(1);          // ✅ Track current page
  const [token, setToken] = useState(null);
  const [expandedComments, setExpandedComments] = useState({}); // Track visibility of comment sections
  const [loggedInUserData, setLoggedInUserData] = useState(null); // Logged-in user's profile
  const [viewedUserData, setViewedUserData] = useState(null); // Profile of the user being viewed
  const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
  const [hasMoreUsers, setHasMoreUsers] = useState(true); // Whether more users are available
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [sendingCommentId, setSendingCommentId] = useState(null); // null = not sending
  const [searchQuery, setSearchQuery] = useState("");
  const [followings, setFollowings] = useState([]);
  const [followingsTotal, setFollowingsTotal] = useState(0);  // ✅ Total followings count
  const [followersTotal, setFollowersTotal] = useState(0);    // ✅ Total followers count
  const [followerFollowStatus, setFollowerFollowStatus] = useState({}); // Track follow status for followers
  const [followedUsers, setFollowedUsers] = useState({});  // ✅ Track clicked users
  const [blockedUsers, setBlockedUsers] = useState({}); // Track blocked users
  const [zoomLevels, setZoomLevels] = useState({}); // Store zoom levels for each image

  // ✅ Get User ID from sessionStorage
  const user = JSON.parse(sessionStorage.getItem("user") || localStorage.getItem("user"));
  const userId = user ? user.id : null;
  const { id } = useParams(); // id is the userId from the route
  const userData = id ? viewedUserData : loggedInUserData;
  const donationPosts = posts.filter(
    (post) => post.is_donation && post.donation_status === "active"


  );
  const photoMedia = posts.flatMap((post) => post.media_url || []).filter(
    (media) => media?.media_type !== "video"
  );
  const videoMedia = posts.flatMap((post) => post.media_url || []).filter(
    (media) => media?.media_type === "video"
  );
  const [editPostData, setEditPostData] = useState(null); // Post to edit
  const [editContent, setEditContent] = useState("");
  const [editMedia, setEditMedia] = useState([]);
  const [editLocation, setEditLocation] = useState("");
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]); // Store uploaded files
  const [filePreviews, setFilePreviews] = useState([]); // Store file previews


  // Inside your component
  const emojiPickerRef = useRef(null);



  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(event.target)
      ) {
        setShowEmojiPicker(false); // ❌ Close if clicked outside
      }
    };

    if (showEmojiPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showEmojiPicker]);


  const [donators, setDonators] = useState([]);
  const [donatorsLoading, setDonatorsLoading] = useState(false);
  const [donatorsCount, setDonatorsCount] = useState(0); // ✅ Add this

  useEffect(() => {
    const fetchDonators = async () => {
      setDonatorsLoading(true);
      try {
        const response = await fetch(`${API_BASE_URL}/donator/get-donators`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
          },
          body: JSON.stringify({
            filters: {},
            page: 1,
            limit: 100,
          }),
        });
        const data = await response.json();
        const donatorsList = data.result?.donators || [];
        setDonators(donatorsList);
        setDonatorsCount(donatorsList.length); // ✅ Store the count
        console.log("Donator Count:", donatorsList.length);
      } catch (err) {
        console.error("Error fetching donators", err);
        setDonators([]);
        setDonatorsCount(0);
      } finally {
        setDonatorsLoading(false);
      }
    };

    fetchDonators(); // ✅ Call on page load
  }, []);
  const calculateDaysLeft = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diffTime = end - start;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays > 0 ? diffDays : 0;
  };

  const openEditPopup = (post) => {
    setEditPostData(post);
    setEditContent(post.content || "");
    setEditMedia(post.media_url || []);
    setEditLocation(post.location || "");
    setIsEditPopupOpen(true);
  };

  const submitEditedPost = async () => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

    const payload = {
      post_id: editPostData?.id,
      content: editContent,
      location: editLocation,
      latitude: "", // Optional
      longitude: "", // Optional
      media_url: editMedia,
      tagged_user_ids: [], // Optional
      hash_tags: [], // Optional
      is_donation: editPostData?.is_donation || false,
      isPublic: true,
    };

    try {
      await axios.post(`${API_BASE_URL}/post/edit-post`, payload, {
        headers: {
          token,
        },
      });
      alert("Post updated successfully!");
      // window.location.reload(); // Reload the page to see the updated post
      setIsEditPopupOpen(false);
      // Optionally refresh posts here
    } catch (error) {
      alert("Failed to update post.");
      console.error(error);
    }
  };

  const handleDeletePost = async (post) => {
    if (!window.confirm("Are you sure you want to delete this post?")) return;
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) {
      alert("You must be logged in to delete a post.");
      return;
    }
    try {
      await axios.post(
        `${API_BASE_URL}/post/edit-post`,
        {
          post_id: post.id,
          media_url: post.media_url || [],
          is_deleted: true,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );
      // Remove the post from UI
      setPosts((prev) => prev.filter((p) => p.id !== post.id));
      setIsOpen(false);
      setIsPopupOpen(false); // <-- close popup if open

    } catch (error) {
      alert("Failed to delete post.");
      console.error(error);
    }
  };
  const handleCommentLikeClick = async (commentId) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

    if (!token || !userId) {
      alert("You must be logged in to like a comment.");
      return;
    }

    // const comment = comments.find((c) => c.id === commentId);
    const comment =
      comments.find((c) => c.id === commentId) ||
      comments.flatMap((c) => c.replies || []).find((r) => r.id === commentId);
    const isLiked = comment?.isLiked;
    const postId = comment?.post_id;  // ✅ use post_id from the comment object

    if (!postId) {
      console.error("❌ Missing post_id in comment object");
      return;
    }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/like/add-like`,
        {
          post_id: Number(postId),
          comment_id: Number(commentId),
          user_id: Number(userId),
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );

      if (response.data.success) {
        setComments((prevComments) =>
          prevComments.map((c) => ({
            ...c,
            replies: c.replies?.map((r) =>
              r.id === commentId
                ? {
                  ...r,
                  likes: isLiked
                    ? Math.max((Number(r.likes) || 0) - 1, 0)
                    : (Number(r.likes) || 0) + 1,
                  isLiked: !isLiked,
                }
                : r
            ),
            ...(c.id === commentId
              ? {
                likes: isLiked
                  ? Math.max((Number(c.likes) || 0) - 1, 0)
                  : (Number(c.likes) || 0) + 1,
                isLiked: !isLiked,
              }
              : {}),
          }))
        );
      } else {
        console.error("Failed to like comment:", response.data.message);
      }
    } catch (error) {
      console.error("Error liking comment:", error);
    }
  };
  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);

    const newMedia = files.map((file) => ({
      file: file, // Store the actual file
      type: file.type.startsWith("image/") ? "image" : "video",
      url: URL.createObjectURL(file), // Generate a preview URL
    }));

    setUploadedMedia((prev) => [...prev, ...newMedia]);
    console.log("New Media Added:", newMedia); // Debugging log
  };

  const handleRemoveFile = (index) => {
    setUploadedMedia((prev) => prev.filter((_, i) => i !== index)); // Remove file
  };

  const handleUnblockFollower = async (friendId) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) return console.error("No token found, please log in.");

    // ✅ Show confirmation popup
    const isConfirmed = window.confirm("Are you sure you want to unblock this user?");
    if (!isConfirmed) return; // Stop execution if user cancels
    // ✅ Get `user1id` from state instead of sessionStorage
    const user = followers.find((f) => f.id === friendId);
    if (!user || !user.user1id) {
      console.error("User1 ID not found.");
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/friend/add-friend`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "token": `${token}`,
        },
        body: JSON.stringify({
          status: "unblock",   // ✅ Use "blocked" status
          user_id: user.user1id,
        }),
      });

      if (!response.ok) throw new Error(`Error: ${response.status}`);

      console.log(`✅ Unblocked user ID: ${friendId}`);

      // ✅ Update UI to show Follow/Block buttons again
      setFollowers((prev) =>
        prev.map((user) =>
          user.id === friendId ? { ...user, isBlocked: false } : user
        )
      );

    } catch (error) {
      console.error("❌ Error unblocking:", error);
    }
  };

  // ✅ Fetch Followings
  const fetchFollowings = async () => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) return console.error("No token found, please log in.");
    const userID = sessionStorage.getItem("userID");

    try {
      const response = await fetch(`${API_BASE_URL}/friend/get-friends`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "token": `${token}`,
        },
        body: JSON.stringify({
          filters: { allFollowings: true },
          page: 1,
          limit: 10,
        }),
      });

      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const data = await response.json();
      console.log("Followings Response:", data.result);   // ✅ Debugging log

      // ✅ Store user2id with corresponding friend_id in sessionStorage
      const user2IdMap = data.result.friends.reduce((acc, friend) => {
        acc[friend.id] = friend.User2.id;  // friend_id => user2id
        return acc;
      }, {});

      sessionStorage.setItem("user2IdMap", JSON.stringify(user2IdMap));
      localStorage.setItem("user2IdMap", JSON.stringify(user2IdMap));
      // ✅ Ensure you're extracting the correct total count
      const totalFollowings = data.result.total || 0;
      setFollowingsTotal(totalFollowings);
      const formattedFollowings = data.result.friends.map((friend) => ({
        id: friend.id,
        friend_id: friend.id,
        first_name: friend.User2.first_name,
        user2id: friend.User2.id,

        username: friend.User2.username,
        profile_picture_url: friend.User2.profile_picture_url || userimg,
        mutualFriendsCount: friend.mutualFriendsCount || 0,
      }));
      console.log("formattedFollowings::", formattedFollowings)
      setFollowings(formattedFollowings);
    } catch (error) {
      console.error("Error fetching followings:", error);
    }
  };
  const handleUnfollow = async (friendId) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) return console.error("No token found, please log in.");
    // ✅ Show confirmation popup
    const isConfirmed = window.confirm("Are you sure you want to unfollow this user?");
    if (!isConfirmed) return; // Stop execution if user cancels

    // ✅ Retrieve the user2id from sessionStorage
    const user2IdMap = JSON.parse(sessionStorage.getItem("user2IdMap") || localStorage.getItem("user2IdMap")) || {};

    // Get the corresponding user2id from the friendId
    const user2id = user2IdMap[friendId];

    if (!user2id) {
      console.error(`User2 ID not found for friend ID: ${friendId}`);
      return;
    }
    try {
      const response = await fetch(`${API_BASE_URL}/friend/add-friend`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "token": `${token}`,
        },
        body: JSON.stringify({
          status: "deleted",    // ✅ Use "unfollow" status
          user_id: user2id,
        }),
      });

      if (!response.ok) throw new Error(`Error: ${response.status}`);

      console.log(`Unfollowed user ID: ${user2id}`);

      // ✅ Remove the user from the followings state
      setFollowings((prev) => prev.filter((user) => user.id !== friendId));

    } catch (error) {
      console.error("Error unfollowing:", error);
    }
  };
  const handleBlockFollower = async (friendId) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) return console.error("No token found, please log in.");

    // ✅ Show confirmation popup
    const isConfirmed = window.confirm("Are you sure you want to block this user?");
    if (!isConfirmed) return; // Stop execution if user cancels

    // ✅ Retrieve the user2id from sessionStorage
    const user1IdMap = JSON.parse(sessionStorage.getItem("user1IdMap")) || {};

    // Get the corresponding user2id from the friendId
    const user1id = user1IdMap[friendId];

    if (!user1id) {
      console.error(`User2 ID not found for friend ID: ${friendId}`);
      return;
    }
    try {
      const response = await fetch(`${API_BASE_URL}/friend/add-friend`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "token": `${token}`,
        },
        body: JSON.stringify({
          status: "blocked",   // ✅ Use "blocked" status
          user_id: user1id,
        }),
      });

      if (!response.ok) throw new Error(`Error: ${response.status}`);

      console.log(`Blocked user ID: ${user1id}`);

      // ✅ Remove the user from the followings state
      // setFollowings((prev) => prev.filter((user) => user.id !== friendId));

      // ✅ Update UI to show "Unblock" instead of Unfollow/Block
      setFollowers((prev) =>
        prev.map((user) =>
          user.id === friendId ? { ...user, isBlocked: true } : user
        )
      );

      // window.location.reload();

    } catch (error) {
      console.error("Error blocking:", error);
    }
  };
  const handleFollowBack = (friendId) => {
    handleFollowerAction(friendId); // Call API function to follow
    setFollowedUsers((prev) => ({ ...prev, [friendId]: true })); // Mark as followed
  };
  const handleFollowerAction = async (friendId) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) return console.error("No token found, please log in.");

    // ✅ Get `user1id` from state instead of sessionStorage
    const user = followers.find((f) => f.id === friendId);
    if (!user || !user.user1id) {
      console.error("User1 ID not found.");
      return;
    }

    console.log("UserID being sent:", user.user1id); // ✅ Debugging log

    try {
      const response = await fetch(`${API_BASE_URL}/friend/add-friend`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "token": `${token}`,
        },
        body: JSON.stringify({
          status: "pending",    // ✅ Use "unfollow" status
          user_id: user.user1id
        }),
      });

      if (!response.ok) throw new Error(`Error: ${response.status}`);

      // Update follow status in state
      setFollowerFollowStatus((prev) => ({
        ...prev,
        [friendId]: true, // Mark the user as followed
      }));

      // Refresh followers and followings lists
      fetchFollowers("", id ? userData?.id : null);
      fetchFollowings();

    } catch (error) {
      console.error("Error handling follower action:", error);
    }
  };

  // Function to fetch user profile and navigate to myprofile page
  const handleUsernameClick = async (userId) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) {
      alert("You must be logged in to view the profile.");
      return;
    }
    // Close modal and reset Swiper before navigating
    setIsPopupOpen(false);
    setThumbsSwiper(null);
    setActiveIndex(0);
    setPlayingIndex(null);
    try {
      // Fetch user profile using the API
      const response = await axios.get(
        `${API_BASE_URL}/user/profile?id=${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );

      if (response.data.success) {
        console.log("User profile fetched successfully:", response.data.result);

        // Redirect to the myprofile page with the user ID
        navigate(`/myprofile/${userId}`);
      } else {
        console.error("Failed to fetch user profile:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };
  const imagespost = [
    crtpostimg,
    goliveprf,
    crtpostimg,
    goliveprf,
    crtpostimg,
    goliveprf,
    // demovideo
  ];
  const isVideo = imagespost[activeIndex]?.type === "video";

  // ...existing imports...
  function linkify(text) {
    const urlRegex = /((https?:\/\/|www\.)[^\s]+)/g;
    const parts = [];
    let lastIndex = 0;
    let match;
    let key = 0;

    while ((match = urlRegex.exec(text)) !== null) {
      if (match.index > lastIndex) {
        parts.push(text.substring(lastIndex, match.index));
      }
      let url = match[0];
      let href = url.startsWith('http') ? url : 'https://' + url;
      parts.push(
        <a key={key++} href={href} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
          {url}
        </a>
      );
      lastIndex = urlRegex.lastIndex;
    }
    if (lastIndex < text?.length) {
      parts.push(text.substring(lastIndex));
    }
    return parts;
  }
  const handleScrollLikedPost = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (scrollTop + clientHeight >= scrollHeight - 10 && hasMoreUsers) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      fetchLikedUsers(selectedPostId, nextPage); // Fetch the next page of users
    }
  };
  // Function to toggle comment section visibility
  const toggleCommentSection = (postId) => {
    setExpandedComments((prev) => ({
      ...prev,
      [postId]: !prev[postId], // Toggle visibility for the specific post
    }));
  };
  // Function to fetch comments for a post
  const fetchComments = async (postId) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

    if (!token) {
      alert("You must be logged in to view comments.");
      return;
    }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/comment/get-comments`,
        {
          filters: { post_id: postId }, // Add post_id to filters
          page: 1,
          limit: 10,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );

      if (response.data.success) {
        // Map the API response to match the UI structure
        const formattedComments = response.data.result.comments.map((comment) => ({
          id: comment.id,
          name: `${comment.user.first_name} ${comment.user.last_name}`, // Combine first and last name
          avatar: comment.user.profile_picture_url || userimg, // Use default avatar if null
          text: comment.content, // Use the content field
          time: new Date(comment.created_at).toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          }), // Format the created_at time
          likes: parseInt(comment.totalLikes, 10), // Convert likes to a number
          replies: [], // Assuming replies are not included in the response
          isLiked: comment.isLiked,
          post_id: comment.post_id,
          is_deleted: comment.is_deleted, // optional: track for debug
          media: comment.media_url || [], // ✅ Include media array
        }));
        console.log("Formatted Comments:", formattedComments); // Debugging log
        setComments(formattedComments); // Update the comments state
        setSelectedPostId(postId); // Track the post ID
        setIsCommentsModalOpen(true); // Open the modal
      } else {
        console.error("Failed to fetch comments:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  };
  useEffect(() => {
    console.log("Updated Comments State:", comments);
  }, [comments]);

  const fetchReplies = async (commentId) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

    if (!token) {
      alert("You must be logged in to view replies.");
      return;
    }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/comment/get-comments`,
        {
          filters: { parent_id: commentId }, // Fetch replies for the specific comment
          page: 1,
          limit: 10,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );

      if (response.data.success) {
        const replies = response.data.result.comments.map((reply) => ({
          id: reply.id,
          name: `${reply.user.first_name} ${reply.user.last_name}`,
          avatar: reply.user.profile_picture_url || userimg,
          text: reply.content,
          time: new Date(reply.created_at).toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          }),
          likes: parseInt(reply.totalLikes, 10),
        }));

        // Update the replies for the specific comment without duplicating
        setComments((prevComments) =>
          prevComments.map((comment) =>
            comment.id === commentId
              ? {
                ...comment,
                replies: [
                  ...comment.replies.filter(
                    (existingReply) =>
                      !replies.some((newReply) => newReply.id === existingReply.id)
                  ), // Keep only unique replies
                  ...replies,
                ],
              }
              : comment
          )
        );
      } else {
        console.error("Failed to fetch replies:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching replies:", error);
    }
  };

  // Function to handle long press on the comment box
  const handleCommentLongPressStart = (postId) => {
    const timeout = setTimeout(() => {
      fetchComments(postId); // Fetch comments on long press
    }, 800); // Trigger after 800ms
    setLongPressTimeout(timeout);
  };

  // Function to cancel long press
  const handleCommentLongPressEnd = () => {
    clearTimeout(longPressTimeout); // Clear the timeout if the press is released early
  };

  // Function to close the comments modal
  const closeCommentsModal = () => {
    setIsCommentsModalOpen(false);
    setComments([]);
  };
  // ✅ Scroll event handler
  const handleScroll = () => {
    if (
      window.innerHeight + document.documentElement.scrollTop + 100 >=
      document.documentElement.scrollHeight
    ) {
      fetchPosts();  // Fetch more posts when scrolled near the bottom
    }
  };

  // ✅ Scroll event listener
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [page, hasMore, id, viewedUserData?.id]);

  const [likingPosts, setLikingPosts] = useState(new Set()); // track posts being liked

  // Function to handle like action
  const handleLikeClick = async (postId) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

    if (!token || !userId) {
      alert("You must be logged in to like a post.");
      return;
    }

    // If this post is already being processed, block the click
    if (likingPosts.has(postId)) return;

    // Mark as being liked
    setLikingPosts((prev) => new Set(prev).add(postId));

    // Find the post to check if it's already liked
    const post = posts.find((p) => p.id === postId);
    const isLiked = post?.isLiked; // Add an `isLiked` property to track the like status

    try {
      const response = await axios.post(
        `${API_BASE_URL}/like/add-like`,
        { post_id: postId, user_id: userId },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );

      if (response.data.success) {
        // Show different toast for like/dislike
        toast.success(isLiked ? "Post disliked successfully!" : "Post liked successfully!");

        // Update the like count and `isLiked` status in the UI
        setPosts((prevPosts) =>
          prevPosts.map((post) =>
            post.id === postId
              ? {
                ...post,
                likeCount: isLiked
                  ? Math.max((Number(post.likeCount) || 0) - 1, 0) // Decrease like count
                  : (Number(post.likeCount) || 0) + 1, // Increase like count
                isLiked: !isLiked, // Toggle the `isLiked` status
              }
              : post
          )
        );
      } else {
        console.error(
          isLiked
            ? "Failed to dislike post:"
            : "Failed to like post:",
          response.data.message
        );
      }
    } catch (error) {
      console.error(
        isLiked ? "Error disliking post:" : "Error liking post:",
        error
      );
    } finally {
      // Remove from tracking so it can be clicked again after operation completes
      setLikingPosts((prev) => {
        const newSet = new Set(prev);
        newSet.delete(postId);
        return newSet;
      });
    }
  };

  // Function to fetch users who liked a post
  const fetchLikedUsers = async (postId) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

    if (!token) {
      alert("You must be logged in to view likes.");
      return;
    }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/like/get-likes`,
        {
          filters: { post_id: postId }, // Add post_id to filters
          page: 0,
          limit: 0,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );

      if (response.data.success) {
        setLikedUsers(response.data.result.users); // Set the list of users who liked the post
        setSelectedPostId(postId); // Track the post ID
        setIsModalOpen(true); // Open the modal
      } else {
        console.error("Failed to fetch liked users:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching liked users:", error);
    }
  };

  // Function to handle long press
  const handleLongPressStart = (postId) => {
    const timeout = setTimeout(() => {
      fetchLikedUsers(postId); // Fetch liked users on long press
    }, 800); // Trigger after 800ms
    setLongPressTimeout(timeout);
  };

  // Function to cancel long press
  const handleLongPressEnd = () => {
    clearTimeout(longPressTimeout); // Clear the timeout if the press is released early
  };
  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
    setLikedUsers([]);
  };
  // Function to handle comment input change
  const handleCommentChange = (postId, value) => {
    setCommentInputs((prev) => ({
      ...prev,
      [postId]: value, // Update the comment input for the specific post
    }));
  };

  const handleCommentSubmit = async (postId, content, uploadedMedia) => {
    if (sendingCommentId === postId) return; // Prevent multiple clicks

    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    const user = JSON.parse(sessionStorage.getItem("user") || localStorage.getItem("user")); // Retrieve user data from sessionStorage

    if (!token) {
      alert("You must be logged in to add a comment.");
      return;
    }
    setSendingCommentId(postId); // ✅ Disable send button for this post

    try {
      let mediaPayload = [];
      if (uploadedMedia && uploadedMedia.length > 0) {
        // Upload files and get the media payload
        mediaPayload = await uploadFiles(uploadedMedia);
      }
      console.log("Media Payload:", mediaPayload); // Debugging log

      const response = await axios.post(
        `${API_BASE_URL}/comment/add-comment`,
        {
          media_url: mediaPayload,
          post_id: postId,
          content: content,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );

      if (response.data.success) {
        const newComment = {
          id: response.data.result.id, // Use the returned ID
          name: `${user.first_name} ${user.last_name}`, // Use first_name and last_name from sessionStorage
          avatar: user.profile_picture_url || userimg, // Use user's profile picture or default avatar
          text: content,
          time: new Date(response.data.result.created_at).toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          }),
          likes: 0,
          replies: [],
        };

        setComments((prevComments) => [...prevComments, newComment]); // Add the new comment to the state

        // alert("Comment added successfully!");
        setPosts((prevPosts) =>
          prevPosts.map((post) =>
            post.id === postId
              ? { ...post, commentCount: (Number(post.commentCount) || 0) + 1 }
              : post
          )
        );
        toast.success("Comment added successfully!"); // Show success message

        setUploadedFiles([]); // Clear uploaded files
        setFilePreviews([]); // Clear file previews

        // Optionally, refresh comments or update the UI
      } else {
        console.error("Failed to add comment:", response.data.message);
      }
      //   window.location.reload(); // Reload the page to see the new comment
    } catch (error) {
      console.error("Error adding comment:", error);
    } finally {
      setSendingCommentId(null); // ✅ Re-enable send button
    }
  };

  const handleInputChange = (e) => {
    setContent(e.target.innerText);
  };
  const toggleTagInput = () => {
    setShowTagInput(!showTagInput); // Toggle visibility
  };
  // Handle video selection with preview
  const handleVideoChange = (event) => {
    const files = Array.from(event.target.files);

    // Check if there's already media
    if (uploadedMedia.length > 0) {
      setError('You can only upload either 5 images or 1 video.');
      return;
    }

    // Create preview URL for video
    const newVideo = files.map(file => ({
      file: file, // Store the actual file
      type: 'video',
      url: URL.createObjectURL(file)
    }));

    setUploadedMedia(newVideo);
    setError(''); // Clear any previous errors
  };
  // Handle media selection with preview
  const handleMediaChange = (event) => {
    const files = Array.from(event.target.files);

    // Check if there's already a video
    if (uploadedMedia.some(media => media.type === 'video')) {
      setError('You can only upload either 5 images or 1 video.');
      return;
    }

    // Check if adding new files would exceed the limit
    if (uploadedMedia.length + files.length > 5) {
      setError('You can only upload up to 5 images.');
      return;
    }

    // Create preview URLs for each file
    const newMedia = files.map(file => ({
      file: file, // Store the actual file
      type: file.type.startsWith('image/') ? 'image' : 'video',
      url: URL.createObjectURL(file)
    }));

    setUploadedMedia(prev => [...prev, ...newMedia]);
    setError(''); // Clear any previous errors
  };

  // Upload files function with pre-signed URL generation and S3 upload
  const uploadFiles = async () => {
    if (uploadedMedia.length === 0) return alert("Please select files");

    const fileData = uploadedMedia.map((media) => ({
      fileName: media.file.name,
      fileType: media.file.type
    }));

    try {
      // Step 1: Generate pre-signed URLs
      const response = await axios.post(
        `${API_BASE_URL}/aws/generate-presigned-url`,
        { files: fileData },
        {
          headers: {
            'token': sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken")
          }
        }
      );

      if (!response.data.success) {
        throw new Error('Failed to generate pre-signed URLs');
      }

      const preSignedUrls = response.data.directory;

      // Step 2: Upload media files to S3
      await Promise.all(
        preSignedUrls.map(async (item, index) => {
          await axios.put(item.presignedUrl, uploadedMedia[index].file, {
            headers: {
              'Content-Type': uploadedMedia[index].file.type,
              'Content-Encoding': 'binary'
            }
          });
          console.log(`${item.fileName} uploaded successfully`);
        })
      );

      return preSignedUrls.map(item => ({
        media_type: item.fileType.startsWith("image") ? "image" : "video",
        url: item.fileUrl // Extract fileUrl from API response
      }));

    } catch (error) {
      console.error('Upload error:', error);
      setError('Failed to upload files. Please try again.');
      throw new Error('Failed to upload files');
    }
  };
  // Handle post submission
  const handlePost = async () => {
    if (!userId) {
      setError("User ID not found. Please log in again.");
      return;
    }
    if (!content && uploadedMedia.length === 0) {
      setError('Please add content or select media.');
      return;
    }
    setLoading(true);
    setError(null);
    console.log("Selected Location Before API Call:", selectedLocation); // Log the selected location

    try {
      let mediaPayload = [];
      if (uploadedMedia.length > 0) {
        mediaPayload = await uploadFiles(); // Get uploaded media URLs
      }


      const response = await axios.post(
        `${API_BASE_URL}/post/add-post`,
        {
          media_url: mediaPayload,
          content,
          tagged_user_ids: taggedUserIds,
          location: selectedLocation, // Include selected location

        },
        {
          headers: {
            'token': sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken")
          }
        }
      );

      if (!response.data.success) {
        throw new Error('Failed to add post');
      }

      setIsPopupOpen(false);
      setContent('');
      setUploadedMedia([]);
      setTaggedUserIds([]);
      setSelectedLocation(""); // Clear selected location

      // Refresh posts if needed
      if (fetchPosts) {
        fetchPosts(true);
      }
    } catch (error) {
      console.error('Failed to add post:', error);
      setError('Failed to add post. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  const fetchFollowers = async (search = "", targetUserId = null) => {
    setLoading(true);
    setError(null);

    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"); // Retrieve the token from sessionStorage

    const requestBody = {
      filters: targetUserId
        ? { user_id_2: targetUserId, status: "accepted", search } // Fetch followers of the viewed profile
        : { allFollowers: true, search }, // Fetch followers of the logged-in user
      page: 1,
      limit: 10, // Adjust the limit as needed
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/friend/get-friends`,
        requestBody,
        {
          headers: {
            "token": `${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        const followersData = response.data.result.friends.map((friend) => ({
          id: friend.id,
          user2id: friend.User1.id, // <-- Add this line

          first_name: friend.User1.first_name,
          last_name: friend.User1.last_name,
          username: friend.User1.username,
          profile_picture_url: friend.User1.profile_picture_url || userimg,
          mutualFriendsCount: friend.mutualFollowersCount || 0,
          user1FollowersCount: friend.user1FollowersCount || 0,
          isBlocked: friend.isBlocked || false,
          myStatus: friend.myStatus || null,
          friendStatus: friend.friendStatus || null,
          cover_picture_url: friend.User1.cover_picture_url || userimg,

        }));

        setFollowers(followersData); // Update the followers state
        setFollowersHidden(!!response.data.result.listHidden);
      } else {
        setError("Failed to fetch followers.");
      }
    } catch (error) {
      console.error("Error fetching followers:", error);
      setError("An error occurred while fetching followers.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setPosts([]);
    if (id) {
      if (
        viewedUserData?.id &&
        (String(viewedUserData.id) === String(id) || viewedUserData.username === id)
      ) {
        fetchPosts(true);
      }
    } else {
      fetchPosts(true);
    }
  }, [id, viewedUserData?.id]);

  useEffect(() => {
    if (id) {
      if (viewedUserData?.id) {
        fetchFollowers("", viewedUserData.id); // Fetch followers of the viewed profile
      }
    } else {
      fetchFollowers(); // Fetch followers of the logged-in user
    }
  }, [id, viewedUserData?.id]);

  const fetchPosts = async (reset = false) => {
    const targetUserId = id ? viewedUserData?.id : userId;
    if (!targetUserId) return;
    if (!reset && (loading || !hasMore)) return;  // Prevent multiple calls

    setLoading(true);
    setError(null);

    // ✅ Retrieve both tokens dynamically
    const emailToken = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    //  const mobileToken = sessionStorage.getItem("accessTokenMobile");

    // ✅ Use mobile token if available, otherwise fallback to email token
    const activeToken = emailToken;

    if (!activeToken) {
      console.error("❌ No authentication token found.");
      setError("Authentication token is missing. Please log in again.");
      setLoading(false);
      return;
    }
    const requestBody = {
      filters: {
        user_id: targetUserId,
      }, page: 1,
      limit: 200
    };
    console.log("Fetching posts for user ID:", requestBody.filters.user_id);

    try {
      const response = await fetch(`${API_BASE_URL}/post/get-posts`, {
        method: "POST",
        headers: {
          "token": `${activeToken}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(requestBody)
      });

      const data = await response.json();

      if (response.ok && data.success) {
        const newPosts = data.result.posts;

        // ✅ Append new posts to the existing ones, skipping any already loaded
        const ownPosts = newPosts.filter(
          (p) => String(p.user_id) === String(targetUserId)
        );
        setPosts((prevPosts) => {
          const base = reset ? [] : prevPosts;
          const existingIds = new Set(base.map((p) => p.id));
          const uniqueNewPosts = ownPosts.filter((p) => !existingIds.has(p.id));
          return [...base, ...uniqueNewPosts];
        });

        // All of the profile's posts come back in this single page-1 request (limit 200), so scrolling has nothing more to load
        setHasMore(false);
        setPage((prevPage) => prevPage + 1);  // Increment the page
      } else {
        setError("Failed to fetch posts.");
      }
    } catch (error) {
      console.error("❌ Error fetching posts:", error);
      setError("An error occurred while fetching posts.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const now = new Date();
    const options = {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };
    const formatted = now.toLocaleString('en-US', options).replace(',', '');
    setCurrentDateTime(formatted);
  }, []);

  const handleContentChange = (e) => {
    const value = e.target.value;
    setContent(value);

    const position = e.target.selectionStart;
    setCursorPosition(position);

    const lastWord = value.slice(value.lastIndexOf(" ") + 1);

    if (lastWord.startsWith("@")) {
      setShowDropdown(true);

      if (!followers?.length) {
        fetchFollowers();
      }

      const query = lastWord.slice(1).toLowerCase();
      const filtered = followers.filter((user) =>
        user.first_name.toLowerCase().includes(query)
      );
      setFilteredUsers(filtered);
    } else {
      setShowDropdown(false);
    }
  };

  const handleTagUser = (user) => {
    const tag = `@${user.first_name}`;
    setContent((prev) => prev + ` ${tag} `);

    // ✅ Add the user's ID to the taggedUserIds array
    setTaggedUserIds((prevIds) => [...new Set([...prevIds, user.id])]);
    setShowDropdown(false);
  };

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const [isPopupOpen, setIsPopupOpen] = useState(false); // 🔹 Popup state

  const openPopup = (post) => {
    // setSelectedPost(post);
    setSelectedPostId(post.id); // Store ID separately if needed
    setIsPopupOpen(true);
    fetchComments(post.id); // 🔥 Fetch comments for the selected post
  };
  const selectedPost = posts.find((p) => p.id === selectedPostId); // lookup

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const toggleReadMore = (index) => {
    setExpandedPosts((prev) => {
      const updated = [...prev];
      updated[index] = !updated[index]; // Toggle specific post
      return updated;
    });
  };
  const [activeTab, setActiveTab] = useState("Posts");
  // Zoom In Function (only for active image)
  const zoomIn = () => {
    setZoomLevels((prev) => ({
      ...prev,
      [activeIndex]: Math.min((prev[activeIndex] || 1) + 0.2, 2), // Max zoom 2x
    }));
  };

  // Zoom Out Function (reset zoom)
  const zoomOut = () => {
    setZoomLevels((prev) => ({
      ...prev,
      [activeIndex]: 1, // Reset to normal size
    }));
  };

  const handleCoverChange = (e) => {
    const file = e.target.files[0];
    if (file && ["image/jpeg", "image/png", "image/jpg"].includes(file.type) && file.size <= 10 * 1024 * 1024) {
      setCoverImage(URL.createObjectURL(file));
    }
  };

  // const [userData, setUserData] = useState(null);
  const [error, setError] = useState(null);

  // Fetch the logged-in user's profile
  const fetchLoggedInUserProfile = async () => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) {
      console.error("No token found. Please log in.");
      return;
    }

    try {
      const response = await axios.get(
        `${API_BASE_URL}/user/profile`,
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );

      if (response.data.success) {
        setLoggedInUserData(response.data.result); // Store logged-in user's profile
      } else {
        console.error("Failed to fetch logged-in user's profile:", response.data.message);
      }
    } catch (err) {
      console.error("Error fetching logged-in user's profile:", err);
    }
  };
  // useEffect(() => {
  //     console.log("Updated userData:", userData); // Log userData when it updates
  // }, [userData]);

  const handleFollowClick = async (userId, privacyStatus) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

    if (!token) {
      console.error("No token found. Please log in.");
      return;
    }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/friend/add-friend`,
        {
          status: "pending",
          user_id: userId
        },
        {
          headers: {
            "token": `${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      if (response.data.success) {
        console.log("✅ Friend request sent successfully:", response.data);

        // ✅ Update UI dynamically
        setPosts((prevPosts) =>
          prevPosts.map((post) =>
            post.user_id === userId
              ? {
                ...post,
                myStatus: privacyStatus === "public" ? "accepted" : "pending" // ✅ Public -> "Following", Private -> "Requested"
              }
              : post
          )
        );
      } else {
        console.error("❌ Failed to send friend request:", response.data.message);
      }
    } catch (error) {
      console.error("❌ Error sending friend request:", error);
    }
  };

  // Fetch profiles based on the URL
  useEffect(() => {
    if (id) {
      // If an ID is present in the URL, fetch the profile of that user
      fetchUserProfile(id);
    } else {
      // Otherwise, fetch the logged-in user's profile
      fetchLoggedInUserProfile();
    }
  }, [id]);

  // Fetch another user's profile
  const fetchUserProfile = async (userId) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) {
      console.error("No token found. Please log in.");
      return;
    }

    try {
      const response = await axios.get(
        `${API_BASE_URL}/user/profile?id=${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );

      if (response.data.success) {
        setViewedUserData(response.data.result); // Store the viewed user's profile
      } else {
        console.error("Failed to fetch user profile:", response.data.message);
      }
    } catch (err) {
      console.error("Error fetching user profile:", err);
    }
  };
  const [followBusy, setFollowBusy] = useState(false);

  // Follow / unfollow (or cancel a pending request) for the profile being viewed
  const handleProfileFollow = async (target) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token || !target?.id || followBusy) return;
    const removing = target.myStatus === "accepted" || target.myStatus === "pending";
    if (removing) {
      const question = target.myStatus === "pending" ? "Cancel your follow request?" : "Are you sure you want to unfollow this user?";
      if (!window.confirm(question)) return;
    }
    setFollowBusy(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/friend/add-friend`,
        { user_id: target.id, status: removing ? "deleted" : "pending" },
        { headers: { "Content-Type": "application/json", token } }
      );
      if (response.data?.success) {
        await fetchUserProfile(target.id);
        fetchFollowers("", target.id);
      }
    } catch (err) {
      alert(err.response?.data?.message || "Something went wrong. Please try again.");
    } finally {
      setFollowBusy(false);
    }
  };

  // Render profile details
  const renderProfileDetails = (userData) => {
    if (!userData) return;

    return (
      <div className="user-details pl-5">

        {userData ? (
          <>
            <p className="flex items-center mb-5 text-[14px]">
              <img src={calendericon} className="mr-2" />{" "}
              <nobr>DOB</nobr>
              <b className="font-semibold ml-1">
                {userData?.date_of_birth ? formatCalendarDateUTC(userData.date_of_birth) : "N/A"}
              </b>
            </p>
            <p className="flex items-start mb-5  text-[14px]">
              <img src={livesicon} className="mr-2" />{" "}
              <nobr>Lives in</nobr>
              <b className="font-semibold ml-1">
                {userData.location || "N/A"}
              </b>
            </p>
            <p className="flex items-center mb-5  text-[14px]">
              <img src={locationicon} className="mr-2" />{" "}
              Country of Origin
              <b className="font-semibold ml-1">
                {userData.country || "N/A"}
              </b>
            </p>
            <p className="flex items-center mb-5  text-[14px]">
              <img src={mobileicon} className="mr-2" /> Mobile
              No
              <b className="font-semibold ml-1">
                {userData.mobile_number || "N/A"}
              </b>
            </p>
            <div className="flex gap-2">
              {(!id || String(userData?.id) === String(userId)) && (
                <button
                  className="flex items-center space-x-2 bg-green-900 text-white px-4 py-2 rounded-full text-sm font-medium edit-profile-cta"
                  onClick={() => navigate("/myprofileedit")} // ✅ Redirect on click
                >
                  <img src={edit} className="mr-2" />
                  <span>Edit Profile</span>
                </button>
              )}
              {id && String(userData?.id) !== String(userId) &&
                userData?.myStatus !== "blocked" && userData?.friendStatus !== "blocked" && (
                <button
                  type="button"
                  disabled={followBusy}
                  onClick={() => handleProfileFollow(userData)}
                  className={`flex items-center px-4 py-2 rounded-full text-sm font-medium disabled:opacity-60 ${
                    userData?.myStatus === "accepted" || userData?.myStatus === "pending"
                      ? "border border-green-900 text-green-900 bg-white"
                      : "bg-green-900 text-white"
                  }`}
                >
                  {userData?.myStatus === "accepted"
                    ? "Unfollow"
                    : userData?.myStatus === "pending"
                    ? "Requested"
                    : userData?.friendStatus === "accepted"
                    ? "Follow Back"
                    : "Follow"}
                </button>
              )}
              {/* Button */}
              <button
                className="flex items-center space-x-2 bg-green-900 text-white px-4 py-2 rounded-full text-sm font-medium intrest-popup-cta"
                onClick={() => setShowModal(true)}
              >
                <img
                  src={intresticon}
                  alt="edit"
                  className="mr-2 w-4 h-4"
                />
                <span>Interests</span>
              </button>

              {showModal && (
                <InterestsModal
                  onClose={() => setShowModal(false)}
                  readOnly={!(!id || String(userData?.id) === String(userId))}
                  viewedUserId={userData?.id}
                />
              )}
            </div>
            {/* Modal */}
          </>
        ) : (
          <p>Loading user details...</p>
        )}

      </div>
    );
  };


  return (

    <div className="dashboard w-full min-h-screen  flex">
      {/* Sidebar */}
      <Leftsidebar />


      <main className="flex-1 min-w-0 p-4 md:p-6 md:pl-8 ">
        <LeftResponsivesidebar />
        <Headmenu />
        {/* Main Content */}
        <main className="block lg:grid lg:grid-cols-[78%_20%]">

          {/* Feeds */}
          <div className="flex-1 lg:pr-5 space-y-6">

            <div className="profile-content ">
              <div className="relative w-full">
                {/* Cover Photo */}
                {/* Cover Photo */}
                <img
                  src={userData?.cover_picture_url || profilebanner} // Use API cover picture or fallback
                  alt="Cover"
                  className="w-full object-cover max-h-[300px] rounded-xl"
                />
                {/* Edit Button */}
                {/* <button className="edit-cover absolute top-0 right-12 bg-[#FFFFFF80] bg-opacity-50 text-[#161F28] px-4 py-2 text-sm flex items-center space-x-2 hover:bg-opacity-75 transition">
                                    <img src={editcover} alt="edit" className="w-4 h-4" />
                                    <span>Edit Cover</span>
                                </button> */}
              </div>

              {profileData.map((post, index) => {
                const maxLength = 150; // Character limit
                const isExpanded = expandedPosts[index]; // Always read from state array
                {/* Post Content with Read More */ }
                <p className="mt-4 mb-4 text-black text-justify break-all">
                  {isExpanded ? post.content : `${post.content.slice(0, maxLength)}...`}

                  {post.content.length > maxLength && (
                    <button
                      onClick={() => toggleReadMore(index)}
                      className="text-[#095228] italic hover:underline font-semibold"
                    >
                      {isExpanded ? "Read Less" : "Read More"}
                    </button>
                  )}</p>
                const handleImageChange = (event) => {
                  const file = event.target.files[0];
                  if (file) {
                    const imageUrl = URL.createObjectURL(file);
                    post.profileimg = imageUrl; // Update the profile image dynamically
                  }
                };

                return (
                  <div className=" space-y-3 profile-body relative">
                    <div className="flex items-end relative content sm:left-5">
                      <div className="profile-dashboard profile-page-dashboard overflow-hidden relative">
                        {/* Profile Image Upload */}
                        <label className="relative cursor-pointer">
                          <input type="file" accept="image/*" className="hidden" onChange={handleImageChange} />
                          {/* Profile Image */}
                          <img
                            src={userData?.profile_picture_url || profileimg} // Use API profile picture or fallback
                            alt="Profile"
                            className="w-full h-full object-cover"
                          />                                                    {/* Camera Icon Overlay */}
                          <div className="absolute">
                            {/* <img src={camera} alt="Edit" className=" text-white" /> */}
                          </div>
                        </label>
                      </div>
                      <div className="feed-title pl-4 relative min-w-0 flex-1">
                        <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
                          <p className="font-semibold text-[20px]">{userData?.first_name} {userData?.last_name || "N/A"}</p>
                          {userData?.verificationBadges?.influencer && (
                            <p
                              className="flex items-center gap-1 bg-[#014F9A] text-[14px] text-[#FFFFFF] px-3 py-0.5 rounded-full"
                              title="Verified Influencer"
                            >
                              <img src={verifybadge} alt="" className="w-4 h-4" />
                              Influencer
                            </p>
                          )}
                        </div>
                        <p className="text-sm text-[#747474]">@{userData?.username || "N/A"}</p>
                        <p className="flex text-sm text-[#747474] font-semibold">
                          <span className="flex items-center followers-profile ml-1 cursor-pointer">
                            {followers.length > 0 && followers.slice(0, 4).map((follower, index) => (
                              <img
                                key={index}
                                src={follower.profile_picture_url || userimg}
                                alt={`Follower ${index + 1}`}
                                className="w-6 h-6 rounded-full border-2 border-white -ml-2 first:ml-0"
                              />
                            ))}
                            <span className="ml-2">{userData?.mutualFollowersCount} Followers</span>
                          </span>
                        </p>
                      </div>

                    </div>
                    <div className="">
                      <div className="user-intro ">
                        <div className="user-intro-flex  mt-5">
                          <div className="intro">
                            <h4 className="font-semibold">Intro</h4>
                            {/* <p>{post.intro}</p> */}
                            {userData ? (
                              <>
                                <p className="flex items-center mb-5">
                                  <p>{userData.bio || "N/A"}</p>
                                </p>
                              </>
                            ) : (
                              <p>Loading user details...</p>
                            )}
                          </div>


                          {/* <div className="user-details pb-5 pl-5">
                                                    {userData ? (
                                                        <>
                                                            <p className="flex items-center mb-5">
                                                                <img src={calendar} className="mr-2" /> DOB
                                                                <b className="font-semibold ml-1">{userData.date_of_birth || "N/A"}</b>
                                                            </p>
                                                            <p className="flex items-start mb-5">
                                                                <img src={house} className="mr-2" /> <nobr>Lives in</nobr>
                                                                <b className="font-semibold ml-1">{userData.location || "N/A"}</b>
                                                            </p>
                                                            <p className="flex items-center mb-5">
                                                                <img src={locationicon} className="mr-2" /> Country of Origin
                                                                <b className="font-semibold ml-1">{userData.country || "N/A"}</b>
                                                            </p>
                                                            <p className="flex items-center mb-5">
                                                                <img src={mobileicon} className="mr-2" /> Phone No
                                                                <b className="font-semibold ml-1">{userData.mobile_number || "N/A"}</b>
                                                            </p>
                                                            <button
                                                                className="flex items-center space-x-2 bg-green-900 text-white px-4 py-2 rounded-full text-sm font-medium edit-profile-cta"
                                                                onClick={() => navigate("/myprofileedit")} // ✅ Redirect on click
                                                            >
                                                                <img src={edit} className="mr-2" />
                                                                <span>Edit Profile</span>
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <p>Loading user details...</p>
                                                    )}
                                                </div> */}
                          <div>
                            {/* Render Profile Details */}
                            {id ? renderProfileDetails(viewedUserData) : renderProfileDetails(loggedInUserData)}
                          </div>
                        </div>

                      </div>

                    </div>
                  </div>
                );
              })}



            </div>
            {/* <div className="mt-4">
                            <h2 className="text-xl font-bold mb-2">Latest Posts</h2>

                            {loading && <p>Loading posts...</p>}

                            {posts?.length > 0 ? (
                                posts.map((post) => (
                                    <div key={post.id} className="share-content relative">
                                        <p><strong>User:</strong> {post.user_id}</p>
                                        <p><strong>Content:</strong> {post.content}</p>
                                        {post.media_url && (
                                            post.media_url.endsWith(".mp4") ? (
                                                <video src={post.media_url} controls width="100%" />
                                            ) : (
                                                <img src={post.media_url} alt="Post" width="100%" />
                                            )
                                        )}
                                        <p><strong>Tagged Users:</strong> {post.tagged_user_ids?.join(", ")}</p>
                                    </div>
                                ))
                            ) : (
                                <p>No posts available.</p>
                            )}
                        </div> */}
            <div className="feed-tabs profile-page-feeds w-full mx-auto mt-1 text-center lg:text-left">
              <div className="flex  items-center gap-x-6 justify-between">
                {/* <h2 className="text-3xl font-semibold tracking-tight text-balance text-black sm:text-4xl">
                                    Feeds
                                </h2> */}
                <div className="filter bg-[] lg:p-3 flex space-x-4">
                  {[
                    "Posts",
                    "Friends",
                    "Photos",
                    "Videos",
                    // Shop tab: only shown when visiting someone else's profile (not your own)
                    // and that user is an active/approved seller.
                    ...(id && userData?.is_seller && userData?.seller?.seller_status === "Approved" ? ["Shop"] : []),
                  ].map((tab) => (
                    <button
                      key={tab}
                      className={`lg:p-3 ${activeTab === tab ? "active focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white" : "text-black"
                        } focus:outline-none`}
                      onClick={() => setActiveTab(tab)}
                    >
                      {tab}
                    </button>
                  ))}
                </div>
              </div>

              {/* Tab Content */}
              <div className="mt-4">
                {/* {activeTab === "Posts" && <div>
                                    {[1, 2, 3].map((post) => (
                                        <div key={post}>
                                            <div className="w-full ">
                                                {profileData.map((post, index) => (
                                                    <FeedPost key={index} post={post} />
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>} */}

                {activeTab === "Posts" && (
                  <div>
                    {/*  */}
                    {loading && <p>Loading posts...</p>}
                    <div className="w-full">

                      {posts.filter((post) => !post.is_donation)?.length > 0 ? (
                        posts
                          .filter((post) => !post.is_donation)
                          .map((post, index) => (
                            <div className="mb-5">
                              <div key={index} className="share-content relative">
                                <div className="flex items-center justify-between">
                                  <div className="flex items-center" >
                                    <img
                                      src={
                                        post.isOwn
                                          ? userData?.profile_picture_url || profileimg
                                          : post.user?.profile_picture_url || profileimg
                                      } alt={post.user?.username || "User"}
                                      className="w-12 h-12 rounded-full mr-4"

                                    />

                                    <div className="flex flex-col justify-between items-start content-between gap-1">

                                      <p
                                        className="font-medium text-[14px] cursor-pointer text-[#000000]" // Call handleUsernameClick on click
                                      >

                                        {post.user?.first_name || "Unknown User"}  {post.user?.last_name || "Unknown User"}
                                      </p>

                                      {post.created_at && (
                                        <p className="text-sm text-gray-500">
                                          {formatDateTime(post.created_at, { hour12: true })}
                                        </p>
                                      )}

                                      {/* <p className="text-sm text-gray-500">{post.user?.email || "No Email"}</p> */}
                                    </div>
                                    {/* Display Location */}
                                    {post.location && (
                                      <div className="mt-2 text-sm text-gray-500">
                                        <FaMapMarkerAlt className="inline-block mr-2 text-gray-400" />
                                        {post.location}
                                      </div>
                                    )}
                                  </div>

                                  {/* :white_check_mark: Conditionally render Follow button */}
                                  {!post.isOwn && (
                                    <button
                                      onClick={() => handleFollowClick(post.user_id, post.user?.privacy_status)}
                                      className={`follow-cta bg-[#095228] text-white px-4 py-1 rounded-full mr-4 ${post.myStatus === "accepted"
                                        ? "bg-gray-400 text-white" // :white_check_mark: Following
                                        : post.myStatus === "pending"
                                          ? "bg-yellow-500 text-black" // :white_check_mark: Requested
                                          : "bg-[#095228] text-white" // :white_check_mark: Follow (default)
                                        }`}
                                      disabled={post.myStatus === "pending" || post.myStatus === "accepted"} // :white_check_mark: Disable after clicking
                                    >
                                      {post.myStatus === "accepted"
                                        ? "Following"
                                        : post.myStatus === "pending"
                                          ? "Requested"
                                          : "Follow"}
                                    </button>
                                  )}
                                </div>
                                <button
                                  placeholder="Share something..."
                                  className=""
                                  onClick={() => openPopup(post)} >
                                  {/* <p className="mt-2 text-left">{post.content}</p> */}

                                  {/* Post Content with Read More */}
                                  <p className="mt-4 mb-4 text-black text-justify break-all">
                                    {expandedPosts[index]
                                      ? linkify(post.content)
                                      : linkify(`${post?.content?.slice(0, 276)}`)
                                    }
                                    {post?.content?.length > 276 && (
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation(); // 🚫 prevent popup
                                          toggleReadMore(index);
                                        }}
                                        className="text-[#095228] italic hover:underline font-semibold ml-2"
                                      >
                                        {expandedPosts[index] ? "Read Less" : "Read More"}
                                      </button>
                                    )}
                                  </p>


                                  {/* :white_check_mark: Render Multiple Media Files */}
                                  <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                    {post?.media_url?.length > 0 && (
                                      post?.media_url?.map((media, mediaIndex) => (
                                        <div key={mediaIndex}>
                                          {media?.media_type === "video" ? (
                                            <PostVideo
                                              src={media?.url}
                                              soundId={post?.sound_id} postId={post?.id}
                                              silenced={post?.rights_enforcement === "mute"}
                                              licenceNeeded={post?.licence_needed}
                                              className="rounded-lg shadow-md object-cover w-full h-[250px]"
                                            />
                                          ) : (
                                            <img
                                              src={media?.url}
                                              alt={`media-${mediaIndex}`}
                                              width="100%"
                                              className="rounded-lg shadow-md object-cover w-full h-[250px]"
                                            />
                                          )}
                                        </div>
                                      ))
                                    )}
                                  </div>
                                </button>
                                {/* Social Buttons */}
                                <div className="react-social-cta flex justify-between items-center mt-8">
                                  <div className="flex space-x-4">
                                    <button className="like flex items-center space-x-1 text-white px-3 py-1"
                                      style={{
                                        background: post.isLiked
                                          ? "#F9E9EA"
                                          : "#BE1F2E",
                                      }}>
                                      {/* Heart Icon: Calls handleLikeClick */}
                                      <img
                                        src={post.isLiked ? RedlikeIcon : Whiteheart} // Use a filled heart icon if liked
                                        alt="Like"
                                        // className="flex items-center space-x-1 px-2 py-1 "
                                        className={`flex items-center space-x-1 px-2 py-1 ${likingPosts.has(post.id) ? 'opacity-50 cursor-not-allowed' : ''
                                          }`}
                                        disabled={likingPosts.has(post.id)}

                                        onClick={() => handleLikeClick(post.id)}

                                      />

                                      {/* Like Count: Calls fetchLikedUsers */}
                                      <span
                                        className="cursor-pointer"
                                        onClick={(e) => {
                                          e.stopPropagation(); // Prevent triggering parent click events
                                          fetchLikedUsers(post.id); // Call fetchLikedUsers
                                        }}
                                      >
                                        {post.likeCount}
                                      </span>
                                    </button>

                                    <button
                                      onClick={() => toggleCommentSection(post.id)} // Toggle comment section

                                      className="comment flex items-center space-x-1 bg-[#666666] text-white px-3 py-1">
                                      <img src={commentIcon} alt="Comment" className="mx-1 space-x-1 px-2 py-1" /> <button
                                        placeholder="Share something..."
                                        className="cursor-pointer"
                                        onClick={openPopup} >{post.commentCount}</button>
                                    </button>


                                  </div>
                                  <button className="flex items-center space-x-1 text-[#fff] share-post-cta">
                                    <img src={shareIcon} alt="Share" className="" />&nbsp;Share
                                  </button>
                                </div>
                                {/* Popup for Liked Users */}
                                {isModalOpen && (
                                  <div className="fixed inset-0 bg-[#00000005] w-full  z-40 flex justify-center items-center">
                                    <div
                                      onScroll={handleScrollLikedPost} // Attach the scroll handler

                                      className="bg-white p-6 rounded-lg  max-w-md w-full z-50 relative">
                                      <h2 className="text-xl font-bold mb-4">Users who liked this post</h2>
                                      <ul>
                                        {likedUsers.length > 0 ? (
                                          likedUsers.map((user, index) => (
                                            <li key={index} className="mb-2 flex items-center justify-between">
                                              <div className="flex items-center">
                                                <img
                                                  src={user.profile_picture_url || profileimg}
                                                  alt={user.username}
                                                  className="w-8 h-8 rounded-full inline-block mr-2"
                                                />
                                                <div>
                                                  <p className="font-bold">{user.username}</p>
                                                  <p className="text-sm text-gray-500">{user.email}</p>
                                                </div>
                                              </div>
                                              <button
                                                onClick={() => handleFollowClick(user.id, user.privacy_status)}
                                                className={`px-4 py-1 rounded-full ${user.myStatus === "accepted"
                                                  ? "bg-gray-400 text-white" // Following
                                                  : user.myStatus === "pending"
                                                    ? "bg-yellow-500 text-black" // Requested
                                                    : "bg-[#095228] text-white" // Follow
                                                  }`}
                                                disabled={user.myStatus === "pending" || user.myStatus === "accepted"} // Disable if already following or requested
                                              >
                                                {user.myStatus === "accepted"
                                                  ? "Following"
                                                  : user.myStatus === "pending"
                                                    ? "Requested"
                                                    : "Follow"}
                                              </button>
                                            </li>
                                          ))
                                        ) : (
                                          <p>No users found.</p>
                                        )}
                                      </ul>
                                      {hasMoreUsers && <p className="text-center text-gray-500 mt-4">Loading more...</p>}

                                      <button
                                        onClick={closeModal}
                                        className="absolute top-2 right-2 text-gray-500 hover:text-red-600"
                                      >
                                        ✕
                                      </button>
                                    </div>
                                  </div>
                                )}

                              </div>
                              {/* Comment Section */}
                              <div className="hidden md:block">
                                {expandedComments[post.id] && ( // Show comment section if expandedComments[post.id] is true

                                  <div className="comment flex justify-between mt-2 items-center border border-[#00000033] w-full p-5">
                                    <div className="flex items-center w-full max-w-[400px]">
                                      <img src={post.user?.profile_picture_url || profileimg} alt="Profile" className="w-10 h-10 rounded-full object-cover" />
                                      <input
                                        type="text"
                                        placeholder="Add a comment..."
                                        value={commentInputs[post.id] || ""} // Bind input to state
                                        onChange={(e) =>
                                          handleCommentChange(post.id, e.target.value)
                                        }
                                        className="flex-1 outline-none px-3 text-gray-700 bg-transparent"
                                      />
                                    </div>
                                    <div className="flex items-center relative gap-1">
                                      <button class="px-2" onClick={() => setShowEmojiPicker((prev) => !prev)}>
                                        <img src={smileyIcon} alt="Smiley" className="w-10 h-auto" />
                                      </button>
                                      {showEmojiPicker && (
                                        <div ref={emojiPickerRef} className="absolute z-50 top-10 left-0">
                                          <Picker
                                            // onSelect={(emoji) =>
                                            //   handleCommentChange(
                                            //     post.id,
                                            //     (commentInputs[post.id] || '') + emoji.native
                                            //   )
                                            // }
                                            data={data}
                                            onEmojiSelect={(emoji) => {
                                              handleCommentChange(post.id, (commentInputs[post.id] || '') + emoji.native);
                                              setShowEmojiPicker(false);
                                            }}
                                            title="Pick an emoji"
                                          />
                                        </div>
                                      )}
                                      <label className="cursor-pointer pr-2">
                                        <img
                                          src={galleryicon}
                                          alt={post.groupName}
                                          className="w-10 h-auto" />
                                        <input
                                          type="file"
                                          multiple
                                          accept="image/*"
                                          className="hidden"
                                          onChange={handleFileUpload}

                                        />
                                      </label>

                                      <button class="px-2">
                                        <img
                                          src={videoicon}
                                          alt={post.groupName}
                                          className="w-10 h-auto" />
                                      </button>

                                      {/* File Previews */}
                                      <div className="file-previews flex flex-wrap gap-4 mt-4">
                                        {uploadedMedia.map((media, index) => (
                                          <div key={index} className="relative">
                                            {media.type === "image" ? (
                                              <img
                                                src={media.url}
                                                alt={`Preview ${index}`}
                                                className="w-20 h-20 object-cover rounded-lg"
                                              />
                                            ) : (
                                              <video
                                                src={media.url}
                                                controls
                                                className="w-20 h-20 object-cover rounded-lg"
                                              />
                                            )}
                                            <button
                                              onClick={() => handleRemoveFile(index)}
                                              className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center"
                                            >
                                              ✕
                                            </button>
                                          </div>
                                        ))}
                                      </div>
                                      {/* <button
                                      onClick={() => handleCommentSubmit(post.id, commentInputs[post.id], uploadedMedia)}
                                      className="bg-[#095228] text-white px-4 py-1 rounded-full">

                                      Send
                                    </button> */}
                                      <button
                                        onClick={() => handleCommentSubmit(post.id, commentInputs[post.id], uploadedMedia)}
                                        disabled={sendingCommentId === post.id}
                                        className={`px-4 py-1 rounded-full ${sendingCommentId === post.id
                                          ? "bg-gray-400 cursor-not-allowed"
                                          : "bg-[#095228] text-white"
                                          }`}
                                      >
                                        {sendingCommentId === post.id ? "Sending..." : "Send"}
                                      </button>

                                      {/* <button
                                        onClick={() => handleCommentSubmit(post.id)} // Submit comment

                                        className="bg-[#095228] text-white px-4 py-1 rounded-full">
                                        Send
                                      </button> */}
                                      {/* Modal for Comments */}
                                      <Modal
                                        isOpen={isCommentsModalOpen}
                                        onRequestClose={closeCommentsModal}
                                        contentLabel="Comments"
                                        className="modal"
                                        overlayClassName="overlay"
                                      >
                                        <h2 className="text-xl font-bold mb-4">Comments</h2>
                                        <ul>
                                          {comments.map((comment, index) => (
                                            <li key={index} className="mb-2">
                                              <p className="font-bold">{comment.user?.username || "Unknown User"}</p>
                                              <p className="text-sm text-gray-500">{comment.content}</p>
                                            </li>
                                          ))}
                                        </ul>
                                        <button
                                          onClick={closeCommentsModal}
                                          className="bg-red-500 text-white px-4 py-2 rounded mt-4"
                                        >
                                          Close
                                        </button>
                                      </Modal>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          ))
                      )
                        : (
                          <p>No posts available.</p>
                        )}
                    </div>
                    <div className="w-full my-8">
                      {posts.filter((post) => post.is_donation).length > 0 ? (
                        posts
                          .filter((post) => post.is_donation)
                          .map((post, index) => (
                            <div key={post.id} className="p-4 border-b bg-[#EBF8ED] home-donation-feeds">
                              <div className="flex items-center">
                                <img
                                  src={post.banner_image?.url || profileimg}
                                  alt={post.user?.username || "banner"}
                                  className="w-full h-full donation-banner mr-4"
                                />
                              </div>

                              <button onClick={() => openPopup(post)} className="">
                                <div className="mt-4 flex gap-3">
                                  {post?.media_url?.length > 0 &&
                                    post.media_url.map((media, mediaIndex) => (
                                      <div key={mediaIndex}>
                                        {media.media_type === "video" ? (
                                          <video
                                            src={media.url}
                                            controls
                                            width="58px"
                                            height="57px"
                                            className="rounded-lg"
                                          />
                                        ) : (
                                          <img
                                            src={media.url}
                                            alt={`media-${mediaIndex}`}
                                            width="130px"
                                            height="120px"
                                            className="rounded-lg"
                                          />
                                        )}
                                      </div>
                                    ))}
                                </div>
                                <div className="flex items-center justify-between my-4 mx-5">
                                  <div>
                                    <h2
                                      className="font-[600] cursor-pointer text-[22px]"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevents the parent button's onClick
                                        handleUsernameClick(post.user?.id);
                                      }}              >
                                      {post?.title || "Unknown User"}
                                    </h2>
                                    <p>                                      {post.title || "Unknown User"}
                                    </p>
                                    <div className="flex items-center justify-start">
                                      {/* <p className="text-sm text-gray-500">{post.user?.date || "No Email"}</p>| */}
                                      <p className="text-sm text-gray-500">
                                        {post.created_at ? formatDateTime(post.created_at) : "No Date"}
                                      </p>
                                      <div className="text-sm text-[#0F5F1A] flex items-center justify-between ml-1">
                                        <img src={greenglobal} alt="" className="w-[10px] h-[10px] mx-1" />
                                        Public
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <p className="mt-2 mx-5 text-left cursor-pointer">{linkify(post.content)}</p>
                                {/* <p className="mt-2 mx-5 text-left cursor-pointer">{post.donationDescription}</p> */}

                                {/* <p className="text-sm text-gray-500">
                                  {post.created_at ? new Date(post.created_at).toLocaleString() : "No Date"}
                                </p> */}
                              </button>

                              {/* Date and Progress */}
                              <div className="flex items-center justify-between gap-3 p-4 rounded-md w-full my-5 mx-2">
                                <ProgressBar
                                  donatorsCount={donatorsCount}
                                  daysLeft={calculateDaysLeft(post.start_date, post.end_date)}
                                  current={Number(post.totalDonatedAmount) || 0}
                                  max={Number(post.donation_target) || 100}
                                  percentage={
                                    (Number(post.totalDonatedAmount || 0) / Number(post.donation_target || 1)) * 100
                                  }
                                />
                                <div className="max-w-[550px] w-full flex items-center gap-2">
                                  <img src={calender} alt="Calendar" />
                                  <span className="text-black font-medium">
                                    {new Date(post.start_date).toLocaleDateString("en-US", {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                    })}{" "}
                                    -{" "}
                                    {new Date(post.end_date).toLocaleDateString("en-US", {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                    })}
                                  </span>
                                </div>
                              </div>

                              {/* Reactions */}
                              <div className="react-social-cta flex justify-between items-center mt-8 mx-5">
                                <div className="flex space-x-4">
                                  <button
                                    className="like flex items-center space-x-1 text-white px-3 py-1"
                                    style={{
                                      background: post.isLiked ? "#F9E9EA" : "#BE1F2E",
                                    }}
                                  >
                                    <img
                                      src={post.isLiked ? RedlikeIcon : Whiteheart}
                                      alt="Like"
                                      className="flex items-center space-x-1 px-2 py-1 "
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleLikeClick(post.id);
                                      }}
                                    />
                                    <span
                                      className="cursor-pointer"
                                      style={{
                                        color: post.isLiked ? "#161F28" : "#FFFFFF",
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        fetchLikedUsers(post.id);
                                      }}
                                    >
                                      {post.likeCount}
                                    </span>
                                  </button>
                                  <button
                                    onClick={() => toggleCommentSection(post.id)}
                                    className="comment flex items-center space-x-1 bg-[#666666] text-white px-3 py-1"
                                  >
                                    <img src={commentIcon} alt="Comment" className="mx-1 flex items-center space-x-1 px-2 py-1 " />
                                    <span className="cursor-pointer">{post.commentCount}</span>
                                  </button>
                                  {/* <button className="eye flex items-center space-x-1 text-black">
                                    <img src={viewIcon} alt="Views" className="mr-1" />
                                    {post.viewsCount} Views
                                  </button> */}
                                </div>
                                {/* <button className="flex items-center space-x-1 text-[#fff] share-post-cta">
                                  <img src={like} alt="Share" />&nbsp;{post.viewsCount}&nbsp;Contributed
                                </button> */}
                              </div>
                            </div>
                          ))
                      ) : (
                        <p>No donation campaigns available.</p>
                      )}
                    </div>
                  </div>
                )}


                {activeTab === "Friends" &&
                  <div className="friends-tab">
                    <div className="flex relative w-full ">
                      <div className="fasearch">
                        <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-300" /></div>
                      <input
                        type="text"
                        placeholder="Find Your Friend"
                        className="search-input focus:outline-none focus:ring-2 focus:ring-gray-300 text-[#000]"
                        value={searchQuery}
                        onChange={e => setSearchQuery(e.target.value)}

                      />

                    </div>
                    {followers.length > 0 ? (
                      followers.map((user) => (
                        <div
                          key={user.id}
                          className="followers followers-friends-profile justify-between border-b-2 border-[#161f2833] pb-6"
                        >
                          <div className="flex">
                            <img
                              src={user.profile_picture_url || userimg}
                              alt="User"
                              className="w-15 h-15 rounded-full cursor-pointer"
                            // onClick={() => handleUsernameClick(user.user2id)}
                            />
                            <div className="pl-4">
                              <p className="titlesemibold" onClick={() => handleUsernameClick(user.user2id || user.id)}
                              >{user.first_name}</p>

                              <p
                                className="text-[12px] text-[#747474] cursor-pointer hover:underline"
                                onClick={() => handleUsernameClick(user.user2id || user.id)}
                              >       @{user.username}
                              </p>
                              <p className="members">
                                {user.user1FollowersCount} Followers{" "}
                                <span className="text-[#D9D9D9] px-1">|</span>{" "}
                                <span className="italic text-[#095228b8] text-[10px] underline">
                                  {user.mutualFriendsCount} Mutual Followers
                                </span>
                              </p>
                            </div>
                          </div>
                          <div className="flex follow-unfollow-cta">
                            {user.isBlocked ? (
                              <button
                                className="unblock-cta my-2 bg-green-500 text-white px-4 py-2 rounded"
                                onClick={() => handleUnblockFollower(user.id)}
                              >
                                Unblock
                              </button>
                            ) : (
                              <>
                                {user.myStatus === null && user.friendStatus === "accepted" ? (
                                  followedUsers[user.id] ? (
                                    <>
                                      <button
                                        className="follow-cta my-2 bg-[#BE1F2E]"
                                        onClick={() => handleUnfollow(user.id)}
                                      >
                                        Unfollow
                                      </button>
                                      <button
                                        className="follow-cta-block  bg-[#BE1F2E]"
                                        onClick={() => handleBlockFollower(user.id)}
                                      >
                                        Block
                                      </button>
                                    </>
                                  ) : (
                                    <button
                                      className="text-[12px] bg-[#095228] text-[#fff] py-2 px-4 rounded-full font-semibold"
                                      onClick={() => handleFollowBack(user.id)}
                                    >
                                      Follow Back
                                    </button>
                                  )
                                ) : (
                                  <button
                                    className="follow-cta-block  bg-[#BE1F2E]"
                                    onClick={() => handleBlockFollower(user.id)}
                                  >
                                    Block
                                  </button>
                                )}

                              </>
                            )}
                          </div>
                        </div>
                      ))
                    ) : (
                      <p className="text-center text-gray-500 mt-4">
                        {followersHidden
                          ? "This user's friends list is private."
                          : id
                            ? "No followers yet."
                            : "You have no followers."}
                      </p>
                    )}
                  </div>}
                {activeTab === "Photos" &&
                  <div className="relative  h-[600px] overflow-y-scroll">
                    {photoMedia.length > 0 ? (
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                        {photoMedia.map((media, index) => (
                          <div key={index}>
                            <img className="h-auto max-w-full w-full rounded-lg" src={media?.url} alt="" />
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="text-center text-gray-500 mt-4">No photos available.</p>
                    )}
                    {/* White Shade Blur Effect */}
                    <div className="sticky bottom-0 left-0 w-full h-[50%] bg-gradient-to-t from-[#ffffffa3] to-transparent pointer-events-none" />
                  </div>
                }
                {activeTab === "Videos" && (
                  <div className="relative  h-[600px] overflow-y-scroll">
                    {videoMedia.length > 0 ? (
                      <div
                        className={`grid gap-4
                                        sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3
                                        auto-rows-[auto]`} // Masonry grid effect
                        style={{ columnGap: '1rem', minHeight: '600px' }}
                      >
                        {videoMedia.map((media, index) => (
                          <div
                            key={index}
                            className={`break-inside-avoid overflow-hidden rounded-lg shadow-md object-cover w-full h-[250px] h-full
                                                ${index % 3 === 0 ? "row-span-2" : index % 4 === 0 ? "row-span-3" : "row-span-1"}`}
                          >
                            <div className="h-full max-w-full w-full rounded-lg overflow-hidden">
                              <ReactPlayer
                                url={media?.url}
                                playing={playingIndex === index}
                                controls
                                width="100%"
                                height="100%"
                                className="rounded-lg h-full profilepost-control"
                                light={groupimg}
                                playIcon={(
                                  <button
                                    className="relative inset-0 flex items-center justify-center bg-[#D9D9D980] bg-opacity-50 rounded-full p-3"
                                    onClick={() => setPlayingIndex(index)}
                                  >
                                    <img src={play} alt="Play" className="w-12 h-12" />
                                  </button>
                                )}
                                onClickPreview={() => setPlayingIndex(index)}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="text-center text-gray-500 mt-4">No videos available.</p>
                    )}
                    {/* White Shade Blur Effect */}
                    <div className="sticky bottom-0 left-0 w-full h-[50%] bg-gradient-to-t from-[#ffffffa3] to-transparent pointer-events-none" />
                  </div>

                )}
                {activeTab === "Shop" && userData?.seller?.id && (
                  <ShopCardList sellerId={userData.seller.id} />
                )}
              </div>
            </div>
            {/* <RightResponsivesidebar /> */}
          </div>
          {/* Right Sidebar */}
          <Rightsidebar />
        </main>
      </main>
      <div>
        {/* Create Post */}

        {/* 🔹 Popup Modal (Shown when isPopupOpen is true) */}
        {isPopupOpen && (
          <div className="popup-share viewpost-popup fixed inset-0 flex items-center justify-center bg-[#000] bg-opacity-60 w-full backdrop-blur-md">
            <div className="border-popup bg-white rounded-lg  relative">
              <div className="flex justify-between">
                <div className="logo-popup flex items-center justify-center space-x-2 ">
                  <img src={pipaanlogo} alt="Nyawoo Logo" className="w-50" />
                </div>
                {/* Close Button */}
                <button className="close-pop-x relative  text-gray-500" onClick={() => setIsPopupOpen(false)}
                >                                <img src={closecircle} alt="Nyawoo Logo" className="w-10 h-10" />
                </button>
              </div>
              {/* Modal Content */}
              {/* Swiper Banner with Thumbnails */}
              <div className="swiper-viewpost-slider">
                <div className="relative">
                  <Swiper
                    modules={[Navigation, Pagination, Thumbs]}
                    navigation
                    pagination={{ clickable: true }}
                    thumbs={{ swiper: thumbsSwiper }} // ✅ Link with thumbnails
                    onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)} // ✅ Track active slide
                    className="rounded-lg mt-4 view-post-swiper"
                  >
                    {selectedPost?.media_url?.map((media, index) => (
                      <SwiperSlide key={index}>
                        {media.media_type === "video" ? (
                          <div className="w-full max-h-[fit-content] rounded-lg overflow-hidden">
                            <ReactPlayer
                              url={media.url}
                              playing={playingIndex === index} // ✅ Play only when clicked
                              controls
                              width="auto"
                              height="100%"
                              className="rounded-lg h-full video-player-swiper"
                              // light={groupimg} // ✅ Thumbnail before playing

                              playIcon={<img src={play} alt="Play" className="player" />}
                            />
                          </div>
                        ) : (
                          <img
                            src={media.url}
                            alt={`Slide ${index}`}
                            className="w-full h-auto max-h-[900px] object-contain  rounded-lg transition-transform duration-300"
                          />
                        )}
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  {/* Zoom Buttons (Apply to Active Image Only) */}
                  <div className="absolute top-0 z-[99] right-4 flex space-x-2 bg-[#ffffffba] rounded-lg items-center">
                    <div className="flex">
                      <button onClick={zoomIn} className=" p-2 rounded-lg ">
                        {/* <img src={zoomInicon}  className="w-[16.8px] h-[16.8px]"/> */}
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                          <path d="M15.7096 15.5001C15.5836 15.5001 15.4576 15.4511 15.3666 15.3601L14.0646 14.0581C13.8756 13.8691 13.8756 13.5611 14.0646 13.3651C14.2536 13.1761 14.5616 13.1761 14.7576 13.3651L16.0596 14.6671C16.2486 14.8561 16.2486 15.1641 16.0596 15.3601C15.9616 15.4511 15.8356 15.5001 15.7096 15.5001Z" fill="#292D32" />
                          <path d="M8.8502 1.5C5.1822 1.5 2.2002 4.482 2.2002 8.15C2.2002 11.818 5.1822 14.8 8.8502 14.8C12.5182 14.8 15.5002 11.818 15.5002 8.15C15.5002 4.482 12.5182 1.5 8.8502 1.5ZM10.7402 8.815H9.51519V10.04C9.51519 10.327 9.27719 10.565 8.9902 10.565C8.7032 10.565 8.4652 10.327 8.4652 10.04V8.815H7.2402C6.9532 8.815 6.7152 8.577 6.7152 8.29C6.7152 8.003 6.9532 7.765 7.2402 7.765H8.4652V6.54C8.4652 6.253 8.7032 6.015 8.9902 6.015C9.27719 6.015 9.51519 6.253 9.51519 6.54V7.765H10.7402C11.0272 7.765 11.2652 8.003 11.2652 8.29C11.2652 8.577 11.0272 8.815 10.7402 8.815Z" fill="#292D32" />
                        </svg>
                      </button>
                      <button onClick={zoomOut} className=" p-2 rounded-lg">
                        {/* <img src={zoomOuticon}  className="w-[16.8px] h-[16.8px]"/> */}
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                          <path d="M10.1002 8.81514H6.6002C6.3132 8.81514 6.0752 8.57714 6.0752 8.29014C6.0752 8.00314 6.3132 7.76514 6.6002 7.76514H10.1002C10.3872 7.76514 10.6252 8.00314 10.6252 8.29014C10.6252 8.57714 10.3872 8.81514 10.1002 8.81514Z" fill="#292D32" />
                          <path d="M8.3498 15.3251C4.3948 15.3251 1.1748 12.1051 1.1748 8.1501C1.1748 4.1951 4.3948 0.975098 8.3498 0.975098C12.3048 0.975098 15.5248 4.1951 15.5248 8.1501C15.5248 12.1051 12.3048 15.3251 8.3498 15.3251ZM8.3498 2.0251C4.9688 2.0251 2.2248 4.7761 2.2248 8.1501C2.2248 11.5241 4.9688 14.2751 8.3498 14.2751C11.7308 14.2751 14.4748 11.5241 14.4748 8.1501C14.4748 4.7761 11.7308 2.0251 8.3498 2.0251Z" fill="#292D32" />
                          <path d="M15.6996 16.0252C15.5666 16.0252 15.4336 15.9762 15.3286 15.8712L13.9286 14.4712C13.7256 14.2682 13.7256 13.9322 13.9286 13.7292C14.1316 13.5262 14.4676 13.5262 14.6706 13.7292L16.0706 15.1292C16.2736 15.3322 16.2736 15.6682 16.0706 15.8712C15.9656 15.9762 15.8326 16.0252 15.6996 16.0252Z" fill="#292D32" />
                        </svg>
                      </button>
                    </div>
                    <span className="h-5 border-r border-[#7A7A7A]"></span>
                    <button className=" p-2 rounded-lg ">
                      {/* <img src={exporticon} className="w-[16.8px] h-[16.8px]" /> */}
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                        <path d="M9.6004 8.32511C9.4674 8.32511 9.3344 8.27611 9.2294 8.17111C9.0264 7.96811 9.0264 7.63211 9.2294 7.42911L14.9694 1.68912C15.1724 1.48612 15.5084 1.48612 15.7114 1.68912C15.9144 1.89212 15.9144 2.22812 15.7114 2.43112L9.9714 8.17111C9.8664 8.27611 9.7334 8.32511 9.6004 8.32511Z" fill="#292D32" />
                        <path d="M15.8996 5.3851C15.6126 5.3851 15.3746 5.1471 15.3746 4.8601V2.0251H12.5396C12.2526 2.0251 12.0146 1.7871 12.0146 1.5001C12.0146 1.2131 12.2526 0.975098 12.5396 0.975098H15.8996C16.1866 0.975098 16.4246 1.2131 16.4246 1.5001V4.8601C16.4246 5.1471 16.1866 5.3851 15.8996 5.3851Z" fill="#292D32" />
                        <path d="M11 16.0251H6.8C2.999 16.0251 1.375 14.4011 1.375 10.6001V6.4001C1.375 2.5991 2.999 0.975098 6.8 0.975098H8.2C8.487 0.975098 8.725 1.2131 8.725 1.5001C8.725 1.7871 8.487 2.0251 8.2 2.0251H6.8C3.573 2.0251 2.425 3.1731 2.425 6.4001V10.6001C2.425 13.8271 3.573 14.9751 6.8 14.9751H11C14.227 14.9751 15.375 13.8271 15.375 10.6001V9.2001C15.375 8.9131 15.613 8.6751 15.9 8.6751C16.187 8.6751 16.425 8.9131 16.425 9.2001V10.6001C16.425 14.4011 14.801 16.0251 11 16.0251Z" fill="#292D32" />
                      </svg>
                    </button>
                  </div>
                </div>
                {/* Thumbnails (Hide if Active Slide is a Video) */}
                {/* Thumbnails (Hide if Active Slide is a Video) */}
                {!isVideo && (
                  <Swiper
                    onSwiper={setThumbsSwiper} // ✅ Set Swiper instance
                    spaceBetween={10}
                    slidesPerView={4}
                    freeMode
                    watchSlidesProgress
                    className="mt-2"
                  >
                    {selectedPost?.media_url?.map((media, index) =>
                      media.media_type === "image" ? (
                        <SwiperSlide key={index} onClick={() => thumbsSwiper.slideTo(index)}>
                          <img
                            src={media.url}
                            alt={`Thumbnail ${index}`}
                            className="w-full h-20 md:h-[200px] object-contain rounded-lg cursor-pointer  border border-[#B4B7C9]"
                          />
                        </SwiperSlide>
                      ) : null
                    )}
                  </Swiper>
                )}
              </div>

              {/* Content Below */}
              <div className="w-full">
                {selectedPostId && selectedPost ? (
                  <div className="share-content relative">
                    <div className="react-social-cta flex justify-between items-center my-8">
                      <div className="flex space-x-4">
                        <button className="like flex items-center space-x-1 border-[#BE1F2E] border-[2px] bg-[#F9E9EA] text-[#161F28] px-3 py-1 gap-2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17" fill="none" className="mr-1">
                            <path d="M9.94944 15.9242C9.66292 16.0253 9.19101 16.0253 8.90449 15.9242C6.46067 15.0899 1 11.6096 1 5.71067C1 3.10674 3.09831 1 5.68539 1C7.2191 1 8.57584 1.74157 9.42697 2.88764C10.2781 1.74157 11.6433 1 13.1685 1C15.7556 1 17.8539 3.10674 17.8539 5.71067C17.8539 11.6096 12.3933 15.0899 9.94944 15.9242Z" stroke="#BE1F2E" stroke-linecap="round" stroke-linejoin="round" />
                          </svg> {selectedPost.likeCount}k
                        </button>
                      </div>
                      <button className="flex items-center space-x-1 text-[#fff] share-post-cta ml-3">
                        <img src={shareIcon} alt="Share" className="" />&nbsp;Share
                      </button>
                    </div>
                    <div className="flex items-center justify-between space-x-3">
                      <div className="flex items-center">
                        <div className="profile-dashboard feed-profile-dashboard overflow-hidden">
                          <img
                            src={selectedPost.user?.profile_picture_url || profileimg}
                            alt={selectedPost.user?.username || "User"}
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <div className="feed-title pl-4">
                          <p className="font-semibold">{selectedPost.user?.username || "Unknown User"}</p>
                          <p className="flex text-sm text-[#747474]">
                            {formatDateOnly(selectedPost.created_at)} |
                            <span className="flex items-center ml-1 cursor-pointer">
                              <img src={greenglobal} alt="" className="mr-1" />
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="flex">

                        <div className="view-sharepost-drpdown">
                          <button
                            onClick={toggleDropdown}
                            className="share-public flex items-center px-2 py-2"
                          >
                            <img src={morecircle} alt="Globe" className="" />
                          </button>

                          {isOpen && (
                            <div className="absolute bg-white shadow-md rounded-md w-40 p-2 right-0">
                              <button onClick={() => openEditPopup(selectedPost)}
                                className="block w-full text-left px-3 py-2 hover:bg-gray-100">Edit</button>
                              <button className="block w-full text-left px-3 py-2 hover:bg-gray-100" onClick={() => handleDeletePost(selectedPost)}
                              > Delete</button>
                              {/* <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 3</button> */}
                            </div>
                          )}
                          {isEditPopupOpen && (
                            <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
                              <div className="bg-white rounded-lg p-6 w-[90%] md:w-[600px] relative">
                                <h2 className="text-xl font-semibold mb-4">Edit Post</h2>

                                <textarea
                                  className="w-full border p-2 mb-3"
                                  value={editContent}
                                  onChange={(e) => setEditContent(e.target.value)}
                                  placeholder="Edit your post content"
                                />

                                {/* Location */}
                                <input
                                  className="w-full border p-2 mb-3"
                                  value={editLocation}
                                  onChange={(e) => setEditLocation(e.target.value)}
                                  placeholder="Location"
                                />

                                {/* Media Previews */}
                                <div className="grid grid-cols-2 gap-3 mb-3">
                                  {editMedia.map((media, index) => (
                                    <div key={index}>
                                      {media.media_type === "video" ? (
                                        <video src={media.url} controls className="w-full h-32 object-cover" />
                                      ) : (
                                        <img src={media.url} className="w-full h-32 object-cover" />
                                      )}
                                    </div>
                                  ))}
                                </div>

                                {/* Submit Button */}
                                <div className="flex justify-end gap-4">
                                  <button
                                    className="bg-gray-300 px-4 py-2 rounded"
                                    onClick={() => setIsEditPopupOpen(false)}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    className="bg-green-600 text-white px-4 py-2 rounded"
                                    onClick={submitEditedPost}
                                  >
                                    Save Changes
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}

                        </div>
                      </div>
                    </div>
                    {selectedPost?.title && (
                      <h2 className="text-2xl font-semibold text-[#095228] ml-[80px] mt-4">
                        {selectedPost.title}
                      </h2>
                    )}

                    <p className="my-4 ml-[80px]">{linkify(selectedPost.content)}</p>                  </div>
                ) : (
                  <p>No posts available.</p>
                )}
              </div>
              {/* CHAT CONTENT AREA */}
              <div className="dashboard w-full  flex mx-auto">
                <main className="flex w-full">
                  <div className="flex flex-col  w-full">
                    {/* CHAT FOOTER (INPUT AREA) */}
                    <CommentSection comments={comments} setComments={setComments} postId={selectedPostId}
                      handleCommentSubmit={handleCommentSubmit}
                      fetchReplies={fetchReplies}
                      userData={userData}  // <-- pass the user profile data
                      fetchComments={fetchComments}
                      postContent={selectedPost?.content} // <-- Pass post content here
                      handleCommentLikeClick={handleCommentLikeClick}
                      handleFileUpload={handleFileUpload}
                      uploadFiles={uploadFiles} // Pass uploadFiles as a prop


                    // Pass the function as a prop
                    />
                  </div>
                </main>
              </div>
            </div>
          </div>
        )}
      </div>
    </div >
  );
}
const CommentSection = ({ comments, setComments, postId, handleCommentSubmit, fetchReplies, userData, handleCommentLikeClick, fetchComments, postContent }) => {
  // const [comments, setComments] = useState([]); // Initialize with an empty array
  console.log("Comments State:", comments); // Debugging log


  const [commentText, setCommentText] = useState("");
  const [replyText, setReplyText] = useState({});
  const [showReplyBox, setShowReplyBox] = useState({});
  const [uploadedMedia, setUploadedMedia] = useState([]); // Track uploaded media
  const [expandedReplies, setExpandedReplies] = useState({}); // Track expanded replies


  const handleFetchReplies = (commentId) => {
    if (!expandedReplies[commentId]) {
      fetchReplies(commentId); // Fetch replies only if not already expanded
      setExpandedReplies((prev) => ({ ...prev, [commentId]: true })); // Mark as expanded
    } else {
      setExpandedReplies((prev) => ({ ...prev, [commentId]: false })); // Collapse replies
    }
  };
  // Function to handle file uploads (if needed)
  // const handleFileUpload = (e) => {
  //     const files = Array.from(e.target.files);
  //     const newMedia = files.map((file) => ({
  //       file: file,
  //       type: file.type.startsWith("image/") ? "image" : "video",
  //       url: URL.createObjectURL(file),
  //     }));
  //     setUploadedMedia((prev) => [...prev, ...newMedia]);
  //   };
  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);

    const newMedia = files.map((file) => ({
      file: file, // Store the actual file
      type: file.type.startsWith("image/") ? "image" : "video",
      url: URL.createObjectURL(file), // Generate a preview URL
    }));

    setUploadedMedia((prev) => [...prev, ...newMedia]);
    console.log("New Media Added:", newMedia); // Debugging log
  };


  // Function to add a reply
  const handleAddReply = async (commentId) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    const user = JSON.parse(sessionStorage.getItem("user") || localStorage.getItem("user")); // Retrieve user data from sessionStorage

    if (!token) {
      alert("You must be logged in to add a reply.");
      return;
    }

    const replyContent = replyText[commentId];
    if (!replyContent?.trim()) return;

    try {
      const response = await axios.post(
        `${API_BASE_URL}/comment/add-comment`,
        {
          media_url: [], // Add media if applicable
          post_id: postId,
          content: replyContent,
          parent_id: commentId, // Use the parent comment ID
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );

      if (response.data.success) {
        const newReply = {
          id: response.data.result.id, // Use the returned ID
          name: `${user.first_name} ${user.last_name}`, // Use first_name and last_name from sessionStorage
          avatar: user.profile_picture_url || userimg, // Use user's profile picture or default avatar
          text: replyContent,
          time: new Date(response.data.result.created_at).toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          }),
          likes: 0,
        };

        setComments((prevComments) =>
          prevComments.map((comment) =>
            comment.id === commentId
              ? { ...comment, replies: [...comment.replies, newReply] }
              : comment
          )
        );

        setReplyText((prev) => ({ ...prev, [commentId]: "" })); // Clear the reply input
        setShowReplyBox((prev) => ({ ...prev, [commentId]: false })); // Hide the reply box
        // alert("Reply added successfully!");
        toast.success("Reply added successfully!"); // Use toast for success message
      } else {
        console.error("Failed to add reply:", response.data.message);
      }
    } catch (error) {
      console.error("Error adding reply:", error);
    }
  };

  const handleSubmitComment = async () => {
    await handleCommentSubmit(postId, commentText, uploadedMedia);
    setCommentText("");  // ✅ clear the text
    setUploadedMedia([]); // ✅ clear the media attachments
  };
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [editingComment, setEditingComment] = useState(null);
  const [editedContent, setEditedContent] = useState("");

  const toggleDropdown = (id) => {
    setOpenDropdownId((prev) => (prev === id ? null : id));
  };

  const startEditingComment = (comment) => {
    setEditingComment(comment);
    setEditedContent(comment.text);
    setOpenDropdownId(null);
  };

  const updateComment = async (comment, userId) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    // const user = JSON.parse(sessionStorage.getItem("user") || localStorage.getItem("user")); // Retrieve user data from sessionStorage

    if (!token) {
      alert("You must be logged in to add a comment.");
      return;
    }
    try {
      const response = await axios.post(
        `${API_BASE_URL}/comment/edit-comment`,
        {
          comment_id: comment.id,
          user_id: userId,
          post_id: comment.post_id,
          content: editedContent,
          media_url: [], // or attach actual media if needed
          is_deleted: false,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );

      if (response.data.success) {
        setComments((prev) =>
          prev.map((c) =>
            c.id === comment.id ? { ...c, text: editedContent } : c
          )
        );
        setEditingComment(null);
        console.log("Comment updated successfully");
      }
    } catch (err) {
      console.error("Error updating comment:", err);
    }
  };

  const deleteComment = async (comment, userId) => {
    if (!window.confirm("Are you sure you want to delete this comment?")) return;
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    // const user = JSON.parse(sessionStorage.getItem("user") || localStorage.getItem("user")); // Retrieve user data from sessionStorage

    if (!token) {
      alert("You must be logged in to add a comment.");
      return;
    }
    try {
      const response = await axios.post(
        `${API_BASE_URL}/comment/edit-comment`,
        {
          comment_id: comment.id,
          user_id: userId,
          post_id: comment.post_id,
          content: comment.text,
          media_url: [],
          is_deleted: true,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      );

      if (response.data.success) {
        setComments((prev) => prev.filter((c) => c.id !== comment.id));
        console.log("Comment deleted successfully");
        await fetchComments(comment.post_id);

      }
    } catch (err) {
      console.error("Error deleting comment:", err);
    }
  };

  return (
    <div className="p-4">


      {/* Display Comments and Replies */}
      {comments.map((comment) => (
        <div key={comment.id} className="mb-4 border-b pb-3 relative">

          <div className="flex gap-3">
            <img
              src={userData?.profile_picture_url || profileimg}
              alt="User Avatar"
              className="w-10 h-10 rounded-full"
            />
            <div className="flex-1">
              <div className="bg-[#FEFDEB] p-3 rounded-[20px]">
                <div className="flex justify-between">
                  <p className="font-semibold">{comment.name}</p>
                  <span className="text-[#9397AD] font-[14px]">{comment.time}</span>
                </div>
                {/* <p className="text-gray-700">{comment.text}</p> */}
                {/* {comment.media?.length > 0 && (
                         <div className="flex flex-wrap gap-2 mt-2">
                           {comment.media.map((media, idx) => (
                             media.media_type === "image" ? (
                               <img
                                 key={idx}
                                 src={media.url}
                                 alt={`comment-media-${idx}`}
                                 className="w-32 h-32 rounded object-cover"
                               />
                             ) : (
                               <video
                                 key={idx}
                                 controls
                                 src={media.url}
                                 className="w-64 h-36 rounded"
                               />
                             )
                           ))}
                         </div>
                       )} */}
                {editingComment?.id === comment.id ? (
                  <div className="mt-2">
                    <textarea
                      className="w-full p-2 border rounded"
                      value={editedContent}
                      onChange={(e) => setEditedContent(e.target.value)}
                    />
                    <button
                      className="mt-1 px-3 py-1 bg-blue-600 text-white rounded"
                      onClick={() => updateComment(comment)}
                    >
                      Save
                    </button>
                  </div>
                ) : (
                  <>
                    <p className="text-gray-700">{comment.text}</p>

                    {/* ✅ Add Media Display Block HERE */}
                    {comment.media?.length > 0 && (
                      <div className="flex flex-wrap gap-2 mt-2">
                        {comment.media.map((mediaItem, idx) => (
                          mediaItem.media_type === "image" ? (
                            <img
                              key={idx}
                              src={mediaItem.url}
                              alt={`comment-media-${idx}`}
                              className="w-32 h-32 rounded object-cover"
                            />
                          ) : mediaItem.media_type === "video" ? (
                            <video
                              key={idx}
                              controls
                              className="w-64 h-36 rounded"
                            >
                              <source src={mediaItem.url} type="video/mp4" />
                            </video>
                          ) : null
                        ))}
                      </div>
                    )}
                  </>)}
                <div className="flex items-center justify-end text-xs text-gray-500 mt-1">
                  <div className="relative">
                    <button onClick={() => toggleDropdown(comment.id)} className="text-gray-500">
                      ⋮
                    </button>
                    {openDropdownId === comment.id && (
                      <div className="absolute right-0 bg-white border rounded shadow-md z-10">
                        <button
                          className="block w-full px-4 py-2 text-left hover:bg-gray-100"
                          onClick={() => startEditingComment(comment)}
                        >
                          Edit
                        </button>
                        <button
                          className="block w-full px-4 py-2 text-left hover:bg-gray-100"
                          onClick={() => deleteComment(comment)}
                        >
                          Delete
                        </button>
                      </div>
                    )}
                  </div>
                  <button
                    className="text-blue-500 text-sm mt-2"
                    onClick={() => handleFetchReplies(comment.id)}
                  >
                    {expandedReplies[comment.id] ? "Hide Replies" : "View Replies"}
                  </button>
                  <button
                    className="ml-4 mr-2 text-[#095228] font-medium "
                    onClick={() =>
                      setShowReplyBox((prev) => ({
                        ...prev,
                        [comment.id]: !prev[comment.id], // Toggle reply box for this comment
                      }))
                    }
                  >
                    Reply
                  </button>
                  <div className="flex items-center space-x-1">
                    {/* ✅ Pass 'reply' instead of 'post' */}
                    <LikeButton reply={comment}
                      onClick={() => handleCommentLikeClick(comment.id)}

                    />
                    <span className="ml-2 flex items-center"><img src={messagetext} /> &nbsp;{comment.replies?.length}</span>
                  </div>
                </div>
              </div>

              {/* Reply Input Box */}

              {showReplyBox[comment.id] && (
                <div className="flex items-center mt-2">
                  <input
                    type="text"
                    value={replyText[comment.id] || ""}
                    onChange={(e) =>
                      setReplyText((prev) => ({
                        ...prev,
                        [comment.id]: e.target.value, // Update reply text for this comment
                      }))
                    }
                    className="flex-1 rounded-[20px] px-4 py-4 text-[#565973] focus:outline-none"
                    placeholder="Write a reply..."
                  />
                  <button
                    onClick={() => handleAddReply(comment.id)}
                    className="ml-2 bg-[#095228] text-[white] px-5 py-2 rounded-[20px]"
                  >
                    Reply
                  </button>
                </div>
              )}
            </div>

          </div>

          {/* Render Replies */}
          {expandedReplies[comment.id] && (

            <div className="ml-14 mt-3">
              {comment.replies.map((reply) => (
                <div key={reply.id} className="flex gap-3 mt-2 relative">
                  <img
                    src={leftconnect}
                    className="absolute left-[-50px] z-99 top-[-51px] h-full"
                  />
                  <img
                    src={userData?.profile_picture_url || profileimg}
                    alt="User Avatar"
                    className="w-8 h-8 rounded-full"
                  />
                  <div className="flex-1">
                    <div className="bg-green-100 p-3 rounded-lg">
                      <div className="flex justify-between">
                        <p className="font-semibold">{reply.name}</p>
                        <span className="text-[#9397AD] text-[14px]">{reply.time}</span>
                      </div>
                      <p className="text-gray-700">{reply.text}</p>
                      {/* ✅ Pass 'reply' instead of 'post' */}
                      <div className="flex items-end justify-end space-x-1">
                        <LikeButton reply={reply}
                          onClick={() => handleCommentLikeClick(reply.id)}

                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
      {/* Input for adding a new comment */}
      <div className="flex items-center mb-4">




        <div className="grp-fam-dashboard grp-fam-page-dashboard overflow-hidden relative mr-3 hidden md:block">
          {/* Profile Image Upload */}
          <label className="relative cursor-pointer">

            <img
              src={userData?.profile_picture_url || profileimg}
              className="w-[80px] h-[70px] rounded-full object-cover "
            />
          </label>
        </div>


        <div className="flex items-center rounded-[20px] border border-[#B4B7C9] bg-white w-full ml-[0px] ">
          <div class="flex space-x-2 ml-3 py-4 microphone-sm">

          </div>

          <input
            placeholder="Add a comment"
            value={commentText}
            onChange={(e) => setCommentText(e.target.value)}
            className="flex-1 rounded-[20px] px-4 py-4 text-[#565973] focus:outline-none "
          />
          <div class="flex space-x-2 ml-3 py-4 chat-media-icon">
            {/* <button class="px-3 smiley">
                     <img
                       src={Smiley}
                       className=""
                     />
                   </button> */}
            {/* <label className="cursor-pointer">
                     <img src={galleryicon} alt="Gallery" />
                     <input
                       type="file"
                       multiple
                       accept="image/*,video/*"
                       className="hidden"
                       onChange={handleFileUpload}
                     />
                   </label> */}
          </div>
          <button class="grp-dashboard-submit-cta text-white px-5 py-3 h-full rounded-[25px] mx-3"
            onClick={handleSubmitComment} // Pass required parameters
          >Send</button>
        </div>
      </div>
    </div>
  );
};
// ✅ Fix: LikeButton is properly structured with useState
const LikeButton = ({ reply, onClick }) => {
  const [liked, setLiked] = useState(false);

  useEffect(() => {
    setLiked(reply?.isLiked || false);
  }, [reply]);

  const handleClick = () => {
    setLiked(!liked);
    onClick(); // Call parent handler
  };

  return (
    <div className="mr-2">
      <span
        className="flex items-center space-x-1 cursor-pointer"
        onClick={handleClick}
      >
        <img
          src={liked ? Redheart : RedlikeIcon}
          alt="Like Icon"
          className={`transition duration-300 ${liked ? "w-6 h-6" : "w-6 h-5"}`}
        />
        <span>{reply?.likes}</span>
      </span>
    </div>
  );
};

// Interest.category is an enum on the API side; fall back to a readable version for any new value
const INTEREST_CATEGORY_LABELS = {
  creative_and_artistic: "Creative & Artistic",
  entertainment_and_pop_culture: "Entertainment & Pop Culture",
};
const formatInterestCategory = (category) =>
  INTEREST_CATEGORY_LABELS[category] || category.replace(/_and_/g, " & ").replace(/_/g, " ");

const InterestsModal = ({ onClose, readOnly = false, viewedUserId }) => {
  const [selected, setSelected] = useState([]);
  const [interests, setInterests] = useState([]);
  const [search, setSearch] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetch(`${API_BASE_URL}/interest/list`, {
      method: "POST",
      headers: { accept: "application/json" },
      body: "", // empty body as per cURL
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setInterests(data.result.interests);
        }
      })
      .catch((err) => console.error("Failed to fetch interests:", err));
  }, []);

  // Toggle selection
  const toggleInterest = (item) => {
    if (readOnly) return;
    setSelected((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  // View mode shows only the viewed user's tags; edit mode shows everything with theirs selected
  const visibleInterests = readOnly
    ? interests
        .map((section) => ({ ...section, tags: section.tags.filter((tag) => selected.includes(tag)) }))
        .filter((section) => section.tags.length > 0)
    : interests;

  // Count only tags that still exist in the master list, so the badge matches what's on screen
  const interestCount = readOnly
    ? visibleInterests.reduce((total, section) => total + section.tags.length, 0)
    : selected.length;

  // The list API has no search param, so filter tags locally and hide categories with no match
  const query = search.trim().toLowerCase();
  const filteredInterests = query
    ? visibleInterests
        .map((section) => ({
          ...section,
          tags: section.tags.filter((tag) => tag.toLowerCase().includes(query)),
        }))
        .filter((section) => section.tags.length > 0)
    : visibleInterests;

  // Reset button is hidden for now; Reset + Save clears all saved interests
  // const reset = () => setSelected([]);

  // Save selected interests
  const saveInterests = async () => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) {
      console.error("No token found in sessionStorage");
      return;
    }

    setSaving(true);
    try {
      await axios.post(
        `${API_BASE_URL}/userinterest/create`,
        { tags: selected }, // selected = ["Photography", "Music"]
        {
          headers: {
            token, // same as your other API call
          },
        }
      );
      toast.success("Interests saved");
      onClose();
    } catch (error) {
      toast.error("Failed to save interests. Please try again.");
      console.error(error);
      setSaving(false);
    }
  };

  useEffect(() => {
    if (readOnly && !viewedUserId) return;

    const fetchUserInterests = async () => {
      const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
      if (!token) {
        console.error("No token found in sessionStorage");
        return;
      }

      try {
        const res = await fetch(
          `${API_BASE_URL}/userinterest/detail`,
          {
            method: "POST",
            headers: readOnly
              ? { accept: "application/json", token, "Content-Type": "application/json" }
              : { accept: "application/json", token },
            body: readOnly ? JSON.stringify({ id: viewedUserId }) : "",
          }
        );
        const data = await res.json();
        if (data.success && data.result?.userInterest?.tags) {
          setSelected(data.result.userInterest.tags); // <-- FIXED PATH
        } else {
          console.warn("No existing interests found.");
        }
      } catch (err) {
        console.error("Failed to fetch user interests:", err);
      }
    };

    fetchUserInterests();
  }, [readOnly, viewedUserId]);

  return (
    <div className="popup-share intrest viewpost-popup fixed inset-0 flex items-center justify-center bg-[#000] bg-opacity-60 w-full backdrop-blur-md">
      <div className="border-popup bg-white rounded-lg  relative">
        <div className="flex justify-between">
          <div className="logo-popup flex items-center justify-center space-x-2 ">
            <img src={pipaanlogo} alt="Nyawoo Logo" className="w-50" />
          </div>
          {/* Close Button */}
          <button
            className="close-pop-x relative  text-gray-500"
            onClick={onClose}
          >
            {" "}
            <img src={closecircle} alt="Nyawoo Logo" className="w-10 h-10" />
          </button>
        </div>
        {/* Header */}
        <div className="px-8">
          <div className="flex justify-between items-center mb-4 title">
            <div className="flex items-center space-x-2">
              <h2 className="text-xl font-semibold">
                {readOnly ? "Interests" : "Select Your Interests"}
              </h2>
              <span className="bg-green-900 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center">
                {String(interestCount).padStart(2, "0")}
              </span>
            </div>
            <div className="flex items-center space-x-4">
              {!readOnly && (
                <>
                  <button
                    className="bg-[#161F28] text-white text-sm px-4 py-2 rounded-md save-cta disabled:opacity-50"
                    onClick={saveInterests}
                    disabled={saving}
                  >
                    {saving ? "Saving..." : "Save"}
                  </button>
                  {/* <button
                    className="border border-gray-400 text-sm text-[#161F28]-400 px-4 py-2 rounded-md reset-cta"
                    onClick={reset}
                  >
                    Reset
                  </button> */}
                </>
              )}
              {/* <button onClick={onClose}>
              <X className="text-green-900" />
            </button> */}
            </div>
          </div>
          <hr className="my-5 bg-[#D9D9D9] p-[1px]"></hr>
          {/* Modal Content */}
          {/* Swiper Banner with Thumbnails */}
          {/* <div className="swiper-viewpost-slider">
          <input
            type="text"
            className="w-full border border-gray-300 rounded-full px-4 py-2 pl-10 focus:outline-none focus:ring-1 focus:ring-green-800"
            placeholder="Search interests"
          />
          <Search className="absolute left-3 top-2.5 text-gray-500" size={18} />
          </div> */}

          {/* Search bar */}
          <div className="relative mb-6 search">
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full border bg-[#F0F0F0] border-gray-300 rounded-full px-4 py-2 pl-10 focus:outline-none focus:ring-1 focus:ring-green-800"
              placeholder="Search interests"
            />
            <Search
              className="absolute left-3 top-2.5 text-[#B8B8B8] search-cta"
              size={18}
            />
          </div>

          {/* Interest Categories */}
          <div className="space-y-6">
            {readOnly && visibleInterests.length === 0 ? (
              <p className="text-sm text-gray-500">No interests added yet</p>
            ) : (
              filteredInterests.length === 0 && (
                <p className="text-sm text-gray-500">No interests found</p>
              )
            )}
            {filteredInterests.map((section) => (
              <div key={section.id} className="mb-8">
                <div className="flex items-center space-x-2 mb-2">
                  <div className="bg-flash-icon" />
                  <h3 className="sec-catagory">{formatInterestCategory(section.category)}</h3>
                </div>
                <div className="flex flex-wrap gap-2">
                  {section.tags.map((item) => {
                    if (readOnly) {
                      return (
                        <span
                          key={item}
                          className="px-3 py-1 text-sm rounded-full border bg-[#39B54A] text-[#FFFFFF] border-[#39B54A] selected-intrest cursor-default"
                        >
                          {item}
                        </span>
                      );
                    }
                    const isSelected = selected.includes(item);
                    return (
                      <button
                        key={item}
                        onClick={() => toggleInterest(item)}
                        className={`px-3 py-1 text-sm rounded-full border ${isSelected
                          ? "bg-[#39B54A] text-[#FFFFFF] border-[#39B54A] selected-intrest"
                          : "bg-[#EBF8ED] text-[#000000] hover:bg-gray-200 unselected-intrest"
                          }`}
                      >
                        {item} {isSelected && <span>×</span>}
                      </button>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};